// i18n namespace `recognition` (pt) — REQ-099 / REQ-102 / REQ-103.
// D-6 (2026-08-01): traducción completa desde el español (idioma fuente). Se retiraron los 34
// marcadores de traducción pendiente que diferían el trabajo a una "Fase 7" inexistente.
const recognition = {
  // Armazon propio del modulo (menu lateral y cabecera): el portal no comparte estos textos.
  shell: {
    backToPortal: 'Voltar ao portal',
    collapseMenu: 'Recolher menu',
    expandMenu: 'Expandir menu',
    fundamentals: 'Fundamentais',
  },
  moduleTitle: 'Programa de Reconhecimento',
  nav: {
    recognize: 'Reconhecer',
    shine: 'Brilhamos Juntos',
    profile: 'Meu perfil',
    admin: 'Admin',
    team: 'Equipa',
    dashboard: 'Painel',
    innovation: 'Inovação LATAM',
  },
  // F8 (paridad demo, H-96/H-97)
  frontlineMore: {
    tab: 'Ver mais',
    title: 'Mais opções',
    documents: 'Documentos',
    language: 'Idioma',
    selectLanguage: 'Selecione o idioma',
  },
  common: {
    loading: 'A carregar…',
    error: 'Não foi possível carregar as informações.',
    retry: 'Tentar novamente',
    empty: 'Ainda não há nada para mostrar.',
    notConfigured: 'O serviço de reconhecimento não está configurado.',
    forbidden: 'Não tem permissão para ver esta secção.',
    close: 'Fechar',
    remove: 'Remover',
    cancel: 'Cancelar',
    insertEmoji: 'Inserir emoji',
    actions: 'Ações',
  },
  recognize: {
    title: 'Reconhecer um colega',
    subtitle: 'Agradeça um comportamento alinhado aos nossos Fundamentais.',
    feedTitle: 'Reconhecimentos recentes',
    feedEmpty: 'Ainda não há reconhecimentos. Seja o primeiro a reconhecer!',
    newCta: 'Novo reconhecimento',
    form: {
      messagePlaceholder: 'Escreva sua mensagem de reconhecimento…',
      anonymous: 'Enviar anonimamente',
      submit: 'Enviar reconhecimento',
    },
  },
  wall: {
    title: 'Mural de reconhecimentos',
    count: '{{count}} reconhecimentos',
    empty: 'Ainda não há reconhecimentos para mostrar.',
    prev: 'Anteriores',
    next: 'Próximos',
    pageOf: 'Página {{page}} de {{total}}',
    for: 'para',
    anonymous: 'Anónimo',
    senderHidden: 'Identidade não visível',
    points_one: '+{{count}} ponto',
    points_other: '+{{count}} pontos',
    pointsTitle: 'Pontos que este reconhecimento vale',
    fundamentalsRecognized: 'Fundamentais reconhecidos',
    fundIconTooltipAria: 'Ver todos os Fundamentais deste reconhecimento',
    behaviorsRecognized: 'Comportamentos reconhecidos',
    habitsRecognized: 'Hábitos diários reconhecidos',
    detailUnavailable: 'Não foi possível carregar o detalhe completo.',
    reportCount: 'Reportado {{count}} vez(es) — em análise',
    receivedIn: 'Recebido em:',
    antiSpoilerBlurredHint: 'Aguarda a cerimónia de premiação do evento Brillamos Juntos para veres as tuas nomeações.',
  },
  reactions: {
    addLabel: 'Reagir',
    countLabel: '{{count}} reações',
    modalTitle: 'Reações',
    error: 'Não foi possível guardar sua reação. Tente novamente.',
    whoReacted: 'Reagiram',
    whoLoading: 'A carregar…',
    whoEmpty: 'Ainda ninguém reagiu.',
    whoError: 'Não foi possível carregar a lista.',
  },
  origin: {
    diario: 'Diário',
    brillamos: 'Brilhamos',
    personalizada: 'Campanha',
    csv: 'Carga em massa',
    delegado: 'Delegado',
    sistema: 'Sistema',
  },
  panel: {
    title: 'Reconheça seus colegas',
    recipientsLabel: 'Pessoas',
    recipientsPlaceholder: 'Procurar por nome…',
    searchError: 'Não foi possível procurar pessoas',
    fundamentalLabel: 'Fundamental (máx. {{max}})',
    fundamentalLabelUnbounded: 'Fundamental',
    maxFundamentalsHint: 'Pode selecionar até {{max}} Fundamental(is).',
    behaviorsLabel: 'Comportamentos',
    habitsLabel: 'Hábitos diários',
    habitRequiredHint: 'Selecione pelo menos um daily habit para poder enviar.',
    summaryLabel: 'Resumo',
    edit: 'Editar',
    messageLabel: 'Sua mensagem',
    messagePlaceholder: 'Por que reconhece esta pessoa?',
    anonymous: 'Enviar anonimamente',
    sendToBrillamos: 'Enviar também para Brillamos',
    charCount: '{{count}} caracteres',
    charsAvailableHint: 'Está a chegar ao limite. Faltam {{remaining}} caracteres de {{max}}.',
    charsLimitReachedHint: 'Chegou ao limite de {{max}} caracteres. Resuma alguma parte para continuar a escrever.',
    charsLimitSentenceNote: 'A frase que criou no post-it também conta para o limite.',
    errMessageTooLong: 'A sua mensagem ultrapassa o máximo de {{max}} caracteres. Resuma alguma parte e envie novamente.',
    errRecipientRequired: 'Escolha a pessoa que quer reconhecer antes de enviar.',
    errFundamentalRequired: 'Escolha pelo menos um Fundamental antes de enviar.',
    errSessionUnknown: 'Não foi possível identificar a sua sessão. Feche a aplicação, entre novamente e tente outra vez.',
    send: 'Enviar',
    sending: 'A enviar…',
    sentTitle: 'Reconhecimento enviado!',
    sentSubtitle: 'Visível para a equipa e o líder.',
    sendErrorGeneric: 'Não foi possível enviar o reconhecimento. Tente novamente.',
    legalHint: 'Deve aceitar os termos legais vigentes antes de reconhecer.',
    sendingDisabledHint: 'O envio de reconhecimentos está temporariamente desativado.',
    scheduleRestrictedHint: 'O envio está fora do horário habilitado para a sua localidade neste momento.',
    weeklyLimitHint: 'Há um limite de {{count}} reconhecimentos por semana para a sua localidade.',
    missingRecipientsHint: 'Selecione pelo menos uma pessoa para reconhecer.',
    missingFundamentalHint: 'Selecione pelo menos um Fundamental.',
    messageMinCharsHint: 'Escreva pelo menos {{count}} caracteres na sua mensagem.',
    missingBehaviorForHabitHint: 'Escolha um comportamento para ver os daily habits disponíveis.',
    noHabitsAvailableHint: 'Este Fundamental não tem daily habits configurados; escolha outro.',
    groupTag: 'Equipa',
    delegateTitle: 'Modo de envio',
    modeSelfTab: 'Em meu nome',
    modeOnBehalfTab: 'Em representação de outro',
    delegateLabel: 'Em nome de',
    delegateSubtitle: 'Pode enviar reconhecimentos em nome de colaboradores de linha de frente.',
    delegatePlaceholder: 'Procurar colaborador…',
    onBehalfActiveBanner: 'Está a reconhecer em representação de {{name}}.',
  },
  profile: {
    title: 'Meu perfil de reconhecimento',
    subtitle: 'Sua atividade de reconhecimento e sua sequência.',
    received: 'Recebidos',
    sent: 'Enviados',
    streak: 'Sequência',
    empty: 'Ainda não tem atividade de reconhecimento.',
    weeksStreak: 'Semanas de sequência',
    monthsStreak: 'Meses de sequência',
    record: 'Recorde',
    totalSent: 'Enviados',
  },
  catalog: {
    title: 'Fundamentais',
    empty: 'O catálogo de Fundamentais está vazio.',
  },
  notifications: {
    title: 'Notificações',
    close: 'Fechar notificações',
    placeholder: 'A caixa de notificações estará disponível em breve.',
    unread: '{{count}} não lidas',
    markAllRead: 'Marcar todas como lidas',
    markRead: 'Marcar como lida',
    readState: 'Estado de leitura',
    inviteToRecognize: 'Reconheça alguém',
    markUnread: 'Marcar como não lida',
    loadMore: 'Ver notificações anteriores',
    recognitionUnavailable: 'Este reconhecimento já não está disponível.',
    unsavedTitle: 'Tem alterações por guardar',
    unsavedDesc: 'Se sair agora, perderá o que está a escrever.',
    unsavedConfirm: 'Sair sem guardar',
    unsavedCancel: 'Ficar aqui',
    campaignInactive: 'A campanha deste reconhecimento já terminou, por isso não é possível abri-la.',
    campaignUnavailable: 'Esta campanha já terminou, por isso não é possível abri-la.',
    unavailable: 'A caixa não está disponível no momento.',
    empty: 'Não tem notificações.',
  },
  // ── WP-12/WP-13 (D4) — Brilhamos+Nomear, Biblioteca, Perfil, Wrapped ──
  home: {
    sent: 'Enviados', received: 'Recebidos', recognizeCta: 'Reconhecer agora', recent: 'Reconhecimentos Recentes',
    active: 'Campanha ativa',
    ended: 'Campanha encerrada',
    daysLeft: '{{count}} dias restantes',
    heroLogoAlt: 'Shine Together',
    nominateNow: 'Nomear agora',
    // Paridade demo (D1/D2) — hero de /app/reconocer, decalcado do HomePage.tsx do demo.
    titleLine1: 'Nomeia quem',
    titleVive: 'vive os',
    subtitle: 'Reconheça um colega que inspira outras pessoas ao viver nossos Fundamentais.',
    cta: '✨ Reconhecer alguém',
    // Paridad demo — estados vacios de los dos muros de la home (HomePage.tsx : 501 / 535).
    emptySent: 'Ainda não reconheceu ninguém!',
    emptyReceived: 'Continue a viver os Fundamentais e logo será reconhecido!',
  },
  streak: {
    title: 'A tua série de reconhecimentos',
    subtitle: 'Reconhece toda a semana e continua a brilhar!',
    subtitleMonthly: 'Reconheça todos os meses e continue a brilhar!',
    weeks: 'sem',
    months: 'meses',
    month: 'mês',
    monthsMany: 'meses',
    record: 'Recorde',
    total: 'Nomeações',
    activeDays: '{{count}} dias ativos esta semana',
    currentLevel: 'NÍVEL ATUAL',
    atRisk: 'Sua sequência está em risco esta semana',
    atRiskMonthly: 'A tua sequência está em risco este mês',
    // FASE 7 (paridade demo, H-91) — família .streak-* unificada.
    current: 'Sequência atual',
    thisWeek: 'Esta semana',
    days: 'dias',
    today: 'Hoje!',
    nudgeDone: 'Já brilhaste hoje! Continua assim 🌟',
    nudgeTodo: 'Reconhece hoje e mantém a tua série! 🚀',
    periodProgress: '{{sent}} de {{min}} esta semana',
    periodProgressDone: 'Meta da semana alcançada! ({{sent}} de {{min}})',
    periodProgressMonthly: '{{sent}} de {{min}} este mês',
    periodProgressDoneMonthly: 'Meta do mês alcançada! ({{sent}} de {{min}})',
    provisionalNote: 'Inclui esta semana · confirma-se no fecho',
    provisionalNoteMonthly: 'Inclui este mês · confirma-se no fecho',
    badgeProvisional: 'NO FECHO',
    badgeProvisionalTooltip: 'Já cumpriu o mínimo deste período: a insígnia já aparece e fica confirmada quando o período terminar.',
    badgesTitle: 'Insígnias',
    celebration: {
      title: 'Insígnia desbloqueada!',
      message: 'Continue assim, sua constância se nota!',
      cta: 'Ótimo!',
    },
    badgeWeek: '{{count}} semana',
    badgeWeeks: '{{count}} semanas',
    badgeWeeksMany: '{{count}} semanas',
    badgeMonth: '{{count}} mês',
    badgeMonths: '{{count}} meses',
    badgeMonthsMany: '{{count}} meses',
    note: '* A sequência é calculada pelos reconhecimentos enviados',
    day: { mon: 'S', tue: 'T', wed: 'Q', thu: 'Q', fri: 'S', sat: 'S', sun: 'D' },
  },
  // 2026-08-10 — só `crossOu` continua em uso (por NominarView). O resto pertencia ao "Feed de
  // atividade" de Brillamos Juntos (`BrillamosFeed`, removido da árvore a pedido do cliente).
  feed: {
    crossOu: 'Cross-OU',
  },
  docs: {
    allLanguages: "Todos os idiomas",
    title: 'Documentos da campanha',
    download: 'Descarregar',
    loadError: 'Não foi possível carregar o documento.',
    cat: {
      howto: 'Como Nomear',
      awards: 'Prémios',
      legal: 'Regulamento',
      privacy: 'Política de Privacidade',
      cookies: 'Política de Cookies',
      notice: 'Aviso Legal',
    },
  },
  library: {
    title: 'Os Fundamentais',
    subtitle: 'A base de como trabalhamos, colaboramos e crescemos na Sigma.',
    watchVideo: 'Ver vídeo',
    behaviorsCount: '{{count}} Atitudes e Comportamentos',
    dailyHabits: 'Hábitos Diários',
    micrositeSpace: 'Espaço do microsite cultural',
  },
  nominate: {
    back: 'Brilhamos Juntos',
    thanksTo: 'Obrigado a {{name}} por',
    demonstrating: 'demonstrar {{fundamental}}',
    defaultMessage: 'Reconhecimento enviado',
    sentTitle: 'Nomeação enviada!',
    sentSubtitle: 'Obrigado por fazer {{name}} brilhar.',
    redirecting: 'A voltar à campanha…',
    yourRecognition: 'Seu reconhecimento',
    thanksWord: 'Obrigado a',
    slotWho: 'quem?',
    forWord: 'por',
    slotWhat: 'o que fez?',
    demonstratingWord: 'demonstrando',
    slotFund: 'fundamental?',
    elements: '{{done}}/3 elementos',
    eyebrow: 'Criar Reconhecimento',
    title: 'Preencha os três campos',
    field1: 'Marque seu colega',
    searchPlaceholder: 'Nome do colega…',
    noResults: 'Não encontramos ninguém com esse nome.',
    field2: 'Em qual Fundamental?',
    field3: 'O que ele fez?',
    noActions: 'Este Fundamental não tem comportamentos configurados.',
    pickFundFirst: 'Escolha primeiro um Fundamental.',
    completeMessage: 'Complete sua mensagem',
    personalizeTitle: 'Personalize sua mensagem',
    personalizeSub: 'Acrescente sua voz. O resto já está pronto.',
    messagePlaceholder: 'Descreva o momento específico que observou…',
    charCount: '{{count}} caracteres',
    idealRange: '30–80 ideal',
    nudgeText: 'Sua mensagem terá mais impacto se acrescentar uma linha própria.',
    addLine: 'Adicionar linha',
    sendAnyway: 'Enviar assim',
    send: 'Enviar Nomeação',
  },
  wrapped: {
    readyTitle: 'Seu Recap está pronto', readySubtitle: 'Reviva os momentos que fizeram seu {{year}} brilhar.', open: 'Ver meu Recap',
    introHint: 'Um panorama do seu ano a reconhecer.',
    topReceptor: 'Quem mais reconheceu',
    topEmisor: 'Seu fã nº 1',
    topFundamentalHint: 'O que mais celebrou.',
    bottomFundamentalHint: 'O que menos celebrou. O teu desafio para este ano.',
    crossOuValue: '{{count}} reconhecimentos cross-OU',
    messageFrom: 'De {{name}}',
    winnerYear: 'Ano {{anio}}',
    winnerPosition: 'Lugar {{position}}',
    sinceMonth: 'O seu resumo abrange desde {{month}}.',
    streakValue: '{{count}} semanas',
    streakValueOne: '{{count}} semana',
    streakValueMany: '{{count}} semanas',
    streakValueMonth: '{{count}} meses',
    streakValueMonthOne: '{{count}} mês',
    streakValueMonthMany: '{{count}} meses',
    unavailable: 'Seu Wrapped ainda não está disponível.',
    // RF-130 correção F1 (H-06) — o backend envia uma CHAVE ESTÁVEL (`GetRecognitionWrappedQueryHandler.cs`),
    // não texto. `WrappedModal.tsx` resolve-a contra estas três, com lista branca: nunca `t(chaveCrua)`.
    generosityTag: {
      generoso: 'Generoso',
      muyGeneroso: 'Muito generoso',
      superGeneroso: 'Super generoso',
    },
  },
  prof: {
    myFolders: 'Meus reconhecimentos recebidos filtrados por Fundamental',
    viewingTitle: 'Perfil de {{name}}',
    backToMine: 'Meu perfil',
    myTeam: 'Equipa',
    searchColleague: 'Procurar um colega…',
    campaignBannerSub: 'A campanha está ativa — entre em Brilhamos Juntos',
    ctaRecognize: 'Reconhecer alguém',
    myWrapped: 'Meu Wrapped {{year}}',
    brillamosFolder: 'Brilhamos Juntos',
    emptySent: 'Ainda não enviou reconhecimentos.',
    emptyBrillamos: 'Ainda não há reconhecimentos de Brilhamos aqui.',
    folderEmpty: 'Ainda não há reconhecimentos nesta pasta.',
    recognizeName: 'Reconhecer {{name}}',
    // FASE 6 (paridade demo, H-75/H-77/H-78) — perfil `.rp2-*`.
    thisWeek: 'Esta semana',
    weekdayInitials: 'S,T,Q,Q,S,S,D',
    badges: 'Insígnias · Shine Together',
    recap: 'Wrapped {{year}}',
    sigmaMsg: '"Obrigado por viver a cultura da Sigma"',
    sigmaFrom: 'Sigma · {{year}}',
    sigmaNote: 'Sem reconhecimentos recebidos em {{year}}. Este reconhecimento é um lembrete do seu valor para a equipa.',
    sigmaNoteSent: 'Sem reconhecimentos enviados em {{year}}. Este reconhecimento é um lembrete do seu valor para a equipa.',
  },
  time: {
    moment: 'Há um instante',
    hours: 'Há {{n}}h',
    yesterday: 'Ontem',
    days: 'Há {{n}} dias',
  },
  // ── WP-11 REQ-104 — Post-it interativo / Word Builder ──
  builder: {
    modeLabel: 'Modo de reconhecimento',
    modeClassic: 'Clássico',
    modeInteractive: 'Interativo',
    previewLabel: 'Pré-visualização do reconhecimento',
    thanksWord: 'Reconheço',
    forWord: 'por',
    demonstratingWord: 'demonstrando',
    slotWho: 'quem?',
    slotWhat: 'o que fez?',
    slotFund: 'fundamental?',
    stepOf: 'Passo {{step}} de {{total}}',
    step1Title: 'Quem reconhece?',
    step3Title: 'Qual comportamento ou hábito?',
    step4Title: 'Adicione sua mensagem',
    complementPlaceholder: 'Descreva o momento específico que observou…',
    noActions: 'Este Fundamental não tem comportamentos nem hábitos configurados.',
    back: 'Voltar',
    next: 'Próximo',
  },
  ri: {
    bankLabel: 'Banco',
    bankTitle: 'Escolha suas palavras',
    bankHint: 'Toque numa palavra aqui em baixo para completar o seu post-it 👇',
    forWhom: 'Para quem é',
    searchPlaceholder: 'Nome do colega…',
    catAccion: 'Fundamentais',
    catComportamiento: 'Comportamentos',
    catHabito: 'Hábitos',
    catImpacto: 'Impacto',
    msgLabel: 'Sua mensagem',
    msgTitle: 'Construa seu reconhecimento',
    words: 'elementos',
    clear: 'Limpar',
    clickToRemove: 'Clique para remover',
    clickHint: 'Clique em uma palavra do banco',
    pickFundFirst: '👆 Escolha um fundamental para ver seus comportamentos',
    pickBehaviorFirst: '👆 Escolha um comportamento para ver seus hábitos',
    noHabitsForFund: '👆 Este Fundamental não tem hábitos configurados',
    howLabel: 'Como funciona?',
    howTitle: 'Três passos simples',
    step1: '<strong>Passe o mouse</strong> sobre uma palavra e o campo de destino se iluminará.',
    step2: '<strong>Clique</strong> na palavra para colocá-la na mensagem.',
    step3: '<strong>Clique no campo</strong> do post-it para remover uma palavra já colocada.',
    quote: 'Reconhecer é nomear o invisível. Quando dizemos a alguém o que vemos nele, tecemos comunidade.',
    cta: 'Complete sua mensagem',
    ctaDone: 'Complete sua mensagem →',
    popupTitle: 'Adicione o toque pessoal',
    popupChars: '30-80 caracteres ideal',
    nudgeMsg: 'Sua mensagem terá mais impacto se acrescentar uma linha própria 💛',
    nudgeAdd: 'Adicionar linha',
    nudgeSkip: 'Enviar assim',
    sent: 'Reconhecimento enviado!',
    sentIntro: 'Obrigado ao meu',
    continueBtn: 'Continuar →',
    seeRecognition: 'Ver meu reconhecimento →',
    clearReset: 'Limpar e começar de novo',
    wStep: 'Passo {{step}} de {{total}}',
    wQPersona: 'Quem reconhece?',
    wQFund: 'Qual fundamental ele viveu?',
    wQBehavior: 'Qual comportamento ele mostrou?',
    wQHabit: 'Qual foi o hábito?',
    wQImpact: 'Qual foi o impacto?',
    templateThanks: 'Reconheço',
    templateForLiving: 'por viver',
    templateWith: 'com',
    templateShowing: ', demonstrando que',
    templateThat: '. Isso',
    slotPersona: 'pessoa',
    slotAccion: 'fundamental',
    slotComportamiento: 'comportamento',
    slotHabito: 'hábito',
    slotImpacto: 'impacto',
    impact1: 'nos inspira',
    impact2: 'nos faz crescer',
    impact3: 'nos alinha',
    impact4: 'move a equipa',
    tooltipFundamental: 'Um Fundamental é o valor que a pessoa viveu.',
    tooltipComportamiento: 'O comportamento concreto que demonstrou esse valor.',
    tooltipHabito: 'O hábito diário onde esse comportamento aparece.',
    tooltipImpacto: 'O efeito que isso teve na equipa.',
    guideStep1Title: 'Escolha suas palavras',
    guideStep1Text: 'Aqui escolhe o Fundamental, comportamento, hábito e impacto que quer reconhecer.',
    guideStep2Title: 'Seu post-it toma forma',
    guideStep2Text: 'Cada palavra escolhida preenche um espaço na frase do seu reconhecimento.',
    guideStep3Title: 'Adicione seu toque pessoal',
    guideStep3Text: 'Esta mensagem é opcional, mas deixa seu reconhecimento mais pessoal.',
    guideStep4Title: 'Envie seu reconhecimento',
    guideStep4Text: 'Quando estiver completo, este botão é ativado e pode enviá-lo.',
    guideReopen: 'Ver o guia novamente',
    guideNext: 'Próximo',
    guideSkip: 'Pular',
    guideDone: 'Entendi',
    progressLabel: '{{value}} de {{total}} etapas concluídas',
  },
  // ── WP-11 REQ-106 — Carga em massa CSV ──
  bulk: {
    or: 'ou',
    open: 'Carga em massa',
    title: 'Carga em massa de reconhecimentos',
    subtitle: 'Envie um CSV com vários reconhecimentos de uma vez, revise e corrija antes de confirmar.',
    stepInstructions: 'Instruções',
    stepUpload: 'Enviar ficheiro',
    stepReview: 'Revisar',
    stepConfirm: 'Confirmar',
    stepOf: 'Passo {{step}} de {{total}}',
    next: 'Próximo',
    back: 'Voltar',
    instructionsIntro: 'Descarregue o modelo, preencha com um colaborador por linha e envie para validar e carregar em lote.',
    matchByIdentity: 'Procure a pessoa pelo email registado ou pelo número de funcionário — basta um dos dois. Não sabe o email? O número de funcionário funciona igualmente bem.',
    onePersonPerRowWarning: 'Importante: cada linha do ficheiro corresponde a UMA só pessoa. Não coloque vários emails ou números de funcionário na mesma célula — se precisar de reconhecer várias pessoas, adicione uma linha por cada uma.',
    // colRequired/colOptional: partilhadas com adminBulkUsers/StepInstructions.tsx (padrão
    // Europa/EUA) — este wizard já não as usa (as suas colunas fixas não têm etiqueta
    // obrigatória/opcional). Não remover numa limpeza deste wizard sem verificar primeiro esse
    // outro consumidor.
    colRequired: 'Obrigatória',
    colOptional: 'Opcional',
    colNameNombre: 'Nome',
    colNameCorreoNomina: 'Correio ou Número de Colaborador',
    colNameFundamental: 'Fundamental',
    colReceptorEmailDesc: 'E-mail de quem recebe o reconhecimento.',
    colMensajeDesc: 'Mensagem do reconhecimento. Pode ser obrigatória conforme sua unidade organizacional.',
    colEmisorEmailDesc: 'E-mail de quem envia. Vazio = o próprio.',
    colReceptorNominaDesc: 'Número de funcionário de quem recebe (AD, SuccessFactors ou o registo Europa). Alternativa ao email — não substitui o ReceptorEmail, serve quando a pessoa ainda não tem email ou não se registou.',
    colEmisorNominaDesc: 'Número de funcionário de quem envia. Vazio = tu.',
    markColumnsTitle: 'E uma coluna para cada Fundamental, Comportamento e Daily Habit',
    markColumnsIntro: 'A seguir a essas colunas fixas vai ver uma coluna para cada um — marque com um X (ou qualquer sinal, como "sim") a que corresponder. Não precisa de escrever nenhum código.',
    markFundamentalHint: 'Marque um ou mais Fundamentais por linha — até ao limite permitido pela sua unidade organizacional.',
    markBehaviorHint: 'O Comportamento é opcional — pode marcar vários.',
    markHabitHint: 'Os Daily Habits são opcionais — pode marcar vários.',
    markColumnsOutro: 'A coluna Mensaje é a última do ficheiro, depois de todas as colunas de marca.',
    downloadTemplate: 'Descarregar modelo',
    templateError: 'Não foi possível descarregar o modelo.',
    catalogError: 'Não foi possível carregar o catálogo de Fundamentais. Tente novamente — sem o catálogo, o ficheiro não pode ser validado.',
    upload: 'Enviar CSV',
    dragDropHint: 'Arraste o ficheiro CSV aqui ou clique para selecioná-lo.',
    invalidFileType: 'Somente ficheiros CSV são aceites.',
    emptyFile: 'O ficheiro não tem linhas de dados.',
    parseError: 'Não foi possível ler o ficheiro CSV.',
    uploadError: 'Não foi possível processar a carga em massa.',
    validRows: '{{count}} linhas válidas',
    invalidRows: '{{count}} com erros',
    reviewHint: 'Corrija as linhas destacadas em vermelho diretamente na tabela; cada alteração é revalidada.',
    colLine: '#',
    colReceptor: 'Destinatário',
    colFundamental: 'Fundamental',
    colMensaje: 'Mensagem',
    colReceptorNomina: 'Nº funcionário',
    colBehavior: 'Comportamento',
    colHabits: 'Daily Habits',
    colStatus: 'Estado',
    ok: 'Válida',
    expandRow: 'Ver detalhe da linha {{line}}',
    collapseRow: 'Ocultar detalhe da linha {{line}}',
    habitsCount_one: '{{count}} Daily Habit',
    habitsCount_other: '{{count}} Daily Habits',
    revalidating: 'Revalidando…',
    downloadErrors: 'Descarregar erros (CSV)',
    confirmSummary: '{{count}} reconhecimentos serão criados. Linhas com erro são ignoradas.',
    confirm: 'Carregar {{count}} válidas',
    committed: '{{created}} reconhecimentos foram criados. {{skipped}} linhas foram ignoradas.',
    duplicatesSkipped_one: '1 reconhecimento não foi enviado: já tinha sido enviado antes com a mesma mensagem.',
    duplicatesSkipped_other: '{{count}} reconhecimentos não foram enviados: já tinham sido enviados antes com a mesma mensagem.',
    notFoundTitle: 'E-mails não encontrados no diretório:',
    errors: {
      receptorRequired: 'O e-mail do destinatário é obrigatório.',
      receptorNotFound: 'Este e-mail não existe no diretório.',
      multiplePeopleNotSupported: 'Esta coluna deve conter apenas uma pessoa (um email ou um número de funcionário). Para reconhecer várias pessoas, adicione uma linha por cada uma.',
      fundamentalInvalid: 'O Fundamental é obrigatório, ou a mensagem não atende ao exigido na sua unidade organizacional.',
      selfRecognition: 'Não pode reconhecer a si mesmo.',
      blockedWord: 'A mensagem contém uma palavra não permitida.',
      weeklyCapExceeded: 'O remetente atingiu o limite semanal de reconhecimentos.',
      duplicateInFile: 'Esta linha está repetida no ficheiro.',
      behaviorInvalid: 'O Comportamento não é válido para o Fundamental desta linha.',
      habitInvalid: 'Um dos Daily Habits não é válido para o Fundamental desta linha.',
      campaignClosed: 'A campanha não está ativa.',
      notAllowedForCampaign: 'Esta linha não é permitida para a campanha deste lote.',
      maxFundamentalsExceeded: 'Não é possível selecionar mais Fundamentais para este reconhecimento: o limite é definido pela configuração da unidade organizacional do remetente.',
      generic: 'Não foi possível validar esta linha.',
    },
  },
  // ── WP-11 REQ-107 — Ações do post-it ──
  actions: {
    // RF-086 / RN-M06 — o catálogo de motivos (`reportReasons`) foi removido: o motivo é texto livre.
    reportCharsLeft: 'Restam {{n}} caracteres',
    edit: 'Editar',
    report: 'Reportar',
    delete: 'Eliminar',
    saveEdit: 'Guardar',
    editError: 'Não foi possível editar o reconhecimento.',
    editMinChars: 'A mensagem tem de ter pelo menos {{min}} carateres ({{count}}/{{min}}).',
    reportReason: 'Motivo do report',
    reportPlaceholder: 'Descreva brevemente o problema…',
    reportError: 'Não foi possível enviar o report.',
    reportSent: 'Report enviado. A nossa equipa irá analisá-lo.',
    sendReport: 'Enviar report',
    deleteConfirm: 'Tem a certeza de que deseja eliminar este reconhecimento? Esta ação não pode ser desfeita.',
    deleteError: 'Não foi possível eliminar o reconhecimento.',
    confirmDelete: 'Sim, eliminar',
  },
  // ── WP-15 — Admin (REQ-126/127/128) ──
  admin: {
    // PLAN WP-U8-T5 — estas claves no existian en ningun locale.
    bulkUsers: {
      title: 'Carregamento em massa do quadro de pessoal (Europa e EUA)',
      descLong: 'Criação e atualização do quadro de pessoal da Europa e EUA por CSV de 24 colunas, mais a região do ficheiro (Europa ou EUA), escolhida ao carregá-lo. É incremental: quem não vier no ficheiro não é alterado, e as saídas assinalam-se com a coluna EMPLOYEE DELETED. As restantes regiões são sincronizadas automaticamente pelo SuccessFactors.',
      importHint: 'Descarregue o modelo, preencha-o e carregue-o. Ao carregar, mostra-se primeiro uma pré-visualização que não escreve nada. Datas no formato MM/dd/aaaa.',
      openWizard: 'Abrir carregamento em massa',
      wizardSubtitle: 'Carregue o CSV do quadro de pessoal, reveja o resultado e confirme — nada é escrito até ao último passo.',
      confirm: 'Confirmar o carregamento',
      downloadErrors: 'Descarregar erros (CSV)',
      received: 'Linhas',
      created: 'Criados',
      updated: 'Atualizados',
      deactivated: 'Desativados',
      skipped: 'Ignorados',
      disabled: 'O carregamento em massa de Europa e EUA está desativado na configuração de fontes.',
      previewNotice: 'Pré-visualização: ainda não foi escrito nada. Estas são as contagens que o carregamento real terá.',
      allOk: 'Todas as linhas foram processadas sem erros.',
      importError: 'Não foi possível processar o ficheiro.',
      importErrorTimeout: 'O servidor demorou demasiado tempo a responder. É possível que o carregamento se tenha concluído na mesma do lado do servidor — verifique o quadro de pessoal antes de tentar novamente. Referência: {{correlationId}}',
      ignoredColumnsNotice: 'Estas colunas do seu ficheiro não são reconhecidas e serão ignoradas: {{columns}}',
      confirmRecap: 'Serão processadas {{total}} linhas: {{created}} novos registos, {{updated}} atualizações, {{deactivated}} desativações.',
      committed: 'Carregamento concluído: {{created}} novos registos, {{updated}} atualizações, {{deactivated}} desativações, {{skipped}} ignoradas.',
      paginationPage: 'Página {{page}} de {{total}}',
      errorColumn: 'Coluna',
      errorDetail: 'Detalhe de erros / omissões',
      ouLabel: 'Região do ficheiro',
      ouPlaceholder: 'Selecione uma região',
      ouEuropa: 'Europa',
      ouUsa: 'Estados Unidos (EUA)',
      ouHint: 'Aplica-se a todas as linhas do ficheiro. Deixou de se escrever linha a linha no CSV, para evitar erros de digitação ou de idioma.',
      ouRequired: 'Selecione a região antes de carregar o ficheiro.',
      col: {
        employeeDeleted: '1 desativa a pessoa; 0 ou vazio mantém-na ativa.',
        localId: 'Número de colaborador. É a chave: sem ele a linha não pode ser processada.',
        firstName: 'Primeiro nome.',
        lastName: 'Apelido.',
        secondLastName: 'Segundo apelido (opcional).',
        completeName: 'Nome completo tal como deve ser apresentado. Se vazio, é composto pelos três campos anteriores.',
        email: 'Correio eletrónico do colaborador. Pode ficar vazio: a ficha permanece no quadro até a pessoa se registar.',
        bu: 'Unidade de negócio.',
        siteId: 'Identificador do local/fábrica.',
        site: 'Nome do local/fábrica.',
        orgDirectionId: 'Identificador da Direção Organizacional.',
        orgDirection: 'Nome da Direção Organizacional.',
        funcDirectionId: 'Identificador da Direção Funcional.',
        funcDirection: 'Nome da Direção Funcional.',
        departmentId: 'Identificador do Departamento.',
        department: 'Nome do Departamento.',
        jobPosition: 'Cargo do colaborador.',
        manager: 'Nome do superior direto (apenas informativo).',
        managerId: 'Número de colaborador do superior direto. Usado para ligar a hierarquia; o superior tem de existir no quadro.',
        managerEmail: 'Correio eletrónico do superior direto (apenas informativo).',
        hireDate: 'Data de admissão, formato MM/dd/aaaa.',
        birthDate: 'Data de nascimento, formato MM/dd/aaaa.',
        notification: "YES ou NO: se a pessoa recebe notificações. Vazio significa 'não definido', não NO.",
        country: 'País da pessoa. Opcional, mas sem ele a pessoa fica fora do âmbito dos administradores de país.',
      },
    },
    title: 'Administração',
    subtitle: 'Configure o Programa de Reconhecimento.',
    denied: 'Não tem permissão para aceder a esta secção.',
    save: 'Guardar',
    saving: 'A guardar…',
    saved: 'Alterações guardadas',
    saveError: 'Não foi possível guardar as alterações.',
    rowsPerPage: 'Linhas por página',
    fundPanelTitle: 'Admin Fundamentais — Reconhecimento',
    fundPanelSubtitle: 'Cada módulo é independente. Ative ou desative conforme as necessidades da sua organização.',
    pager: {
      showing: 'A mostrar {{range}} de {{total}}',
      perPage: '{{size}} por pág.',
      all: 'Todas',
      prev: 'Página anterior',
      next: 'Próxima página',
      pageSize: 'Resultados por página',
    },
    nav: {
      roles: 'Configurar funções e permissões',
      points: 'Pontos',
      moderation: 'Moderação',
      winners: 'Vencedores',
      campaigns: 'Campanhas',
      reports: 'Relatórios',
      team: 'Equipa',
      dashboard: 'Painel',
      management: 'Gestão',
      notifications: 'Notificações',
      views: 'Visualizações',
      docs: 'Documentação',
      recap: 'Recap',
    },
    roles: {
      title: 'Configurar funções e permissões',
      desc: 'Gira administradores, seu alcance por OU/país e sua matriz de permissões.',
      searchEmail: 'Procurar por e-mail…',
      empty: 'Não há administradores para mostrar.',
      colAdmin: 'Administrador',
      colRole: 'Função',
      colScope: 'Alcance',
      colStatus: 'Estado',
      allScopes: 'Todas',
      active: 'Ativo',
      inactive: 'Inativo',
      edit: 'Editar',
      remove: 'Remover',
      removeConfirmTitle: 'Remover administrador do Brillamos',
      removeConfirmMsg: 'Remover "{{name}}" como administrador do Brillamos? A conta mantém-se como colaborador padrão.',
      removeConfirm: 'Sim, remover',
      removeError: 'Não foi possível remover o papel de administrador. Tenta novamente.',
      status: 'Estado',
      permMatrix: 'Matriz de permissões',
      readOnlyConflict: '«Apenas leitura» não pode coexistir com permissões de escrita (RN-R03). Estão assinaladas: {{permisos}}. Ao alterar qualquer caixa fica resolvido; se guardar assim, o servidor recusa.',
      addAdmin: 'Adicionar administrador',
      addTitle: 'Adicionar administrador',
      editTitle: 'Editar administrador — {{name}}',
      searchPersonLabel: 'Procurar colaborador',
      searchPersonPlaceholder: 'Nome ou e-mail do colaborador…',
      alreadyAdminNote: 'Esta pessoa já é administradora de Reconhecimento — edite os dados abaixo.',
      cannotEditGlobal: 'Esta pessoa já tem o papel de Admin Geral. Esse papel não é gerenciado por aqui.',
      selectRolePlaceholder: 'Selecione uma função…',
      selectRoleFirst: 'Escolha uma função antes de guardar.',
      saveForbidden: 'Não tem permissão para fazer esta alteração.',
      role: {
        AdminGlobal: 'Admin Geral',
        AdminBrillamos: 'Admin Reconhecimento',
        AdminOUBrillamos: 'Admin OU Reconhecimento',
      },
    },
    perm: {
      manageUsers: 'Gerir utilizadores',
      manageRecognitions: 'Gerir reconhecimentos',
      manageNotifications: 'Gerir notificações',
      manageDocuments: 'Gerir documentos',
      manageWinners: 'Gerir vencedores',
      viewAnalytics: 'Ver analytics',
      viewReports: 'Ver relatórios',
      exportData: 'Exportar dados',
      configureViews: 'Configurar visualizações',
      bulkCsv: 'Envio em massa (CSV)',
      moderateContent: 'Moderar conteúdo',
      manageCampaigns: 'Gerir campanhas',
      createCampaigns: 'Criar e gerir campanhas',
      readOnly: 'Somente leitura',
      approveNominations: 'Confirmar Vencedores',
      managePoints: 'Gestão',
      manageRoles: 'Configurar funções e permissões',
      manageBlockedWords: 'Gerir palavras bloqueadas',
      managePointsConfig: 'Pontos',
      manageRecap: 'Editar Recap anual',
      delegateRecognition: 'Reconhecer em nome de outro',
      accessCatalogFundamentals: 'Catálogo de Fundamentais',
      accessCatalogOus: 'Catálogo de OUs',
    },
    points: {
      title: 'Pontos',
      desc: 'Configure os pontos por critério (0-9), em espelho Staff/Frontline. Os pontos nunca são visíveis para o colaborador.',
      empty: 'Nenhum critério de pontos configurado.',
      seg: { staff: 'Staff', frontline: 'Frontline' },
      segmentActive: 'Ativo',
      segmentActiveHint: 'Se estiver desativada, esta tabela (Staff ou Frontline) não atribui pontos mesmo que tenha critérios configurados.',
      lockedCampaign: 'A configuração não é editável com uma campanha já iniciada.',
      campaignActiveWarning: 'Não é possível editar a configuração de pontos enquanto houver uma campanha ativa nesta unidade organizacional.',
      colCategory: 'Categoria',
      colCriterion: 'Critério',
      colPoints: 'Pontos',
      colActive: 'Ativo',
      criterionActiveHint: 'Se estiver desativado, este critério não atribui pontos mesmo quando é cumprido.',
      colAccumulated: 'Total acumulado',
      accumulatedFooter: 'Nomeações avaliadas',
      resetAccumulated: 'Repor a 0',
      resetAccumulatedConfirmTitle: 'Repor o acumulado',
      resetAccumulatedConfirmMessage: 'O contador de "Total acumulado" desta OU e segmento será reposto a 0. O histórico de reconhecimentos NÃO é apagado; deixa apenas de ser contado a partir de agora. Esta ação não pode ser anulada.',
      resetAccumulatedSuccess: 'O acumulado foi reposto a 0.',
      resetAccumulatedError: 'Não foi possível repor o acumulado.',
      accumulatedError: 'Não foi possível carregar a contagem de nomeações.',
      accumulatedDisabledHint: 'Com os pontos desativados o motor não avalia, pelo que o acumulado fica a zero mesmo havendo reconhecimentos.',
      globalToggle: 'Aplicam-se pontos (global)',
      globalToggleHint: 'Ativa ou desativa o sistema de pontos para TODAS as unidades organizacionais, independentemente do que cada uma tenha configurado individualmente.',
      visibleToEmployees: 'Visível para colaboradores',
      visibleToEmployeesHint: 'Mostra no post-it os pontos de cada reconhecimento desta OU. Nunca o acumulado de uma pessoa.',
      visibleUnknown: 'Não foi possível ler o estado do interruptor. Nada muda até se saber.',
      visibleGdprBlocked: 'Esta OU está sujeita ao RGPD: os pontos não são mostrados mesmo com o interruptor ligado.',
      globalOffHint: 'O interruptor global está desligado: nenhuma OU credita pontos, mesmo que a sua tabela esteja ativa.',
      ouPicker: 'Unidade organizacional',
      ouPickPlaceholder: 'Selecione uma unidade…',
      pickOuFirst: 'Selecione uma unidade organizacional para ver e editar a sua configuração de pontos.',
      accumulatedNoKey: 'Este critério não tem chave canónica, pelo que não é possível associá-lo à contagem.',
      globalOverriddenHint: 'Esta unidade tem uma exceção própria, pelo que aqui o interruptor está {{estado}} independentemente do valor global.',
      globalOn: 'ligado',
      globalOff: 'desligado',

      globalUnknown: 'Não foi possível ler o interruptor global; o seu estado real é desconhecido.',
      noOuInProfile: 'O seu perfil não tem uma unidade organizacional atribuída, pelo que não há configuração de pontos para mostrar. Peça-o ao administrador global.',
      exportReport: 'Descarregar relatório de pontos',
      exporting: 'A descarregar…',
      exportError: 'Não foi possível gerar o relatório de pontos. Tente novamente.',
      exportEmpty: 'Não existem linhas de pontos para exportar neste âmbito.',
      exportTruncated: 'O relatório foi truncado em {{tope}} linhas; reduza o âmbito para exportar tudo.',
      exportNamesUnresolved: 'Não foi possível resolver alguns nomes; essas linhas saem com o respetivo identificador.',
      exportColPerson: 'Pessoa',
      exportColOu: 'Unidade organizacional',
      exportColPoints: 'Pontos'
    },
    placeholder: {
      soon: 'Esta secção estará disponível em breve.',
      tracked: 'Acompanhamento: {{req}}',
    },
    recognitions: {
      title: 'Reconhecimentos',
      descLong: 'Gira o catálogo de Fundamentais/Hábitos: criação, edição, ativar/desativar, vincular a campanha e microsite.',
      tabActive: 'Fundamentais',
      tabTrash: 'Lixeira',
      tabHabits: 'Daily Habits',
      newHabit: 'Novo Daily Habit',
      habitSearchPlaceholder: 'Procurar hábito…',
      habitsEmpty: 'Não há Daily Habits no catálogo.',
      colColor: 'Cor',
      colNameEs: 'Nome (ES)',
      colNameEn: 'Nome (EN)',
      colParent: 'Fundamental pai',
      colOuVisibility: 'Visibilidade por OU',
      ouInherited: 'Herda do fundamental',
      habitStatusAll: 'Todos',
      habitStatusActive: 'Ativos',
      habitStatusInactive: 'Inativos',
      deleteHabitConfirm: 'Eliminar este Daily Habit do catálogo?',
      newHabitTitle: 'Novo Daily Habit',
      editHabitTitle: 'Editar Daily Habit',
      new: 'Novo Fundamental',
      searchPlaceholder: 'Pesquisar por código ou nome…',
      empty: 'O catálogo está vazio.',
      colCode: 'Código',
      colName: 'Nome',
      colHabits: 'Hábitos',
      colBrillamos: 'Brilhamos',
      colMicrosite: 'Microsite',
      colStatus: 'Estado',
      inBrillamos: 'Em Brilhamos',
      notInBrillamos: 'Fora',
      openMicrosite: 'Abrir',
      edit: 'Editar',
      deleteConfirm: 'Enviar este Fundamental para a lixeira?',
      trashEmpty: 'A lixeira está vazia.',
      newTitle: 'Novo Fundamental',
      editTitle: 'Editar {{code}}',
      needAllLangs: 'Preencha o nome nos 7 idiomas.',
      fieldCode: 'Código',
      fieldOrder: 'Ordem',
      fieldName: 'Nome',
      fieldShortName: 'Nome curto',
      fieldColor: 'Cor',
      fieldMicrosite: 'URL do microsite',
      fieldCampaignScope: 'Campanha vinculada',
      campaignScopeHint: 'Id da campanha (vazio = catálogo global)',
      fieldBrillamos: 'Participa de Brilhamos Juntos',
      legacyCatalogWarning: 'Este catálogo é temporário: as alterações aqui ainda não são refletidas no que as pessoas veem ao reconhecer (P2-010).',
    },
    moderation: {
      desc: 'Palavras bloqueadas e caixa de reports.',
      title: 'Moderação',
      descLong: 'Caixa de reports com encaminhamento, catálogo de palavras bloqueadas e chaves de moderação.',
      contentTitle: 'Moderação de Conteúdo',
      wordsTitle: 'Palavras Bloqueadas',
      wordsDesc: 'São detectadas e bloqueadas automaticamente ao enviar um reconhecimento.',
      wordsCounted: 'palavras bloqueadas',
      manageWords: 'Gerir',
      wordsManagerDesc: 'Adicione, edite ou remova palavras por idioma. Compatível com mais de 100 palavras.',
      newWord: 'Nova palavra',
      region: 'País/Região',
      regionGlobal: 'Global (todas)',
      regionHint: 'O mesmo idioma pode ter palavras diferentes por país ou região.',
      allRegions: 'Todas as regiões',
      searchWord: 'Procurar…',
      editWord: 'Editar palavra',
      word: 'Palavra',
      wordPlaceholder: 'Ex.: inapropriado…',
      language: 'Idioma',
      addWord: 'Adicionar',
      wordsEmpty: 'Nenhuma palavra corresponde ao filtro.',
      langOther: 'Outros',
      // RF-082 — tabela país→idiomas que define qual catálogo se aplica a cada emissor.
      countryLanguagesTitle: 'Países e idiomas',
      countryLanguagesDesc: 'Defina quais idiomas são falados em cada país. Um país multilíngue (Bélgica: nl e fr) aplica as palavras de todos os seus idiomas sem as registar duas vezes. Países em ISO-3166 (MX, ES, BE) e idiomas entre os 7 da plataforma (es, en, pt, fr, de, nl, ro). Para restringir uma palavra a um país específico, use o campo País/Região dela.',
      countryLanguagesEmpty: 'A tabela de países e idiomas está vazia.',
      regionsTitle: 'Regiões',
      regionMembers: 'Países que a compõem',
      countryLanguagesInvalid: 'Revise estes códigos antes de guardar: {{codes}}. O país usa ISO de 2 letras (MX) e o idioma precisa ser um dos 7 da plataforma (es, en, pt, fr, de, nl, ro), sem variante de país.',
      countryLanguagesUnreadable: 'Não foi possível ler a tabela, então não dá para guardar: guardar a substitui inteira e o que não está visível seria perdido.',
      country: 'País',
      languages: 'Idiomas',
      languagesPlaceholder: 'nl, fr',
      addCountry: 'Adicionar país',
      countryPlaceholder: 'MX',
      autoTitle: 'Configuração de Auto-Moderação',
      aiAutoBlock: 'Bloqueio automático por IA',
      aiAutoBlockHint: 'Quando ativo, cada mensagem de reconhecimento é verificada por IA (Azure AI Content Safety) ao ser enviada e bloqueada se for ofensiva.',
      helpAria: 'Ajuda',
      aiHelp: 'Verifica cada mensagem com IA (Azure AI Content Safety) ao ser enviada e deteta toxicidade em contexto (ódio, ameaças, assédio). É adicional ao catálogo de palavras bloqueadas: ambos podem estar ativos ao mesmo tempo. Requer que "Moderação ativa (global)" esteja ligada; com o interruptor global desligado, esta camada não se aplica.',
      globalHelp: 'Interruptor principal da moderação. Se estiver desligado, NADA é moderado: nem o bloqueio por IA, nem o catálogo de palavras bloqueadas, nem se aceitam denúncias. Ligue-o para que as outras camadas funcionem.',
      wordsHelp: 'Bloqueia palavras exatas ao enviar, independentemente do contexto. Complementa o bloqueio por IA (que deteta toxicidade em contexto). Ambas as camadas requerem que "Moderação ativa (global)" esteja ligada.',
      hideThreshold: 'Limite de reports para ocultar',
      notifyReporter: 'Notificar quem reportou',
      aiPendingNote: 'Com o bloqueio automático por IA ativo, as mensagens de reconhecimento são validadas pelo Azure AI Content Safety ao serem enviadas e recusadas se violarem as normas de convivência. Funciona em conjunto com o catálogo de palavras bloqueadas.',
      hideThresholdHint: 'Quantas denúncias são necessárias para ocultar um reconhecimento automaticamente. O valor 1 é a regra vigente: oculta na primeira denúncia.',
      notifyReporterHint: 'Guarda a preferência e a envia junto com o evento de moderação. O e-mail ao denunciante será enviado pelo NotificationService quando essa notificação existir.',
      advanced: 'Configuração avançada',
      globalEnabled: 'Moderação ativa (global)',
      reportEnabledGlobal: 'Reportar habilitado por padrão',
      dailyReportLimit: 'Limite diário de reports',
      // RF-084 — excecoes de "permitir reports" por no, em cascata Site -> BU -> OU -> global.
      overridesTitle: 'Reportar por unidade (cascata)',
      overridesDesc: 'Exceções ao valor global. Vale a do nó mais específico: Site, depois BU, depois OU e suas unidades superiores. Uma unidade sem exceção herda a da unidade acima.',
      overridesNode: 'Unidade, BU ou Site',
      overridesNodePlaceholder: 'Escolha uma OU ou insira um id de BU/Site',
      overridesAllow: 'Permitido',
      overridesBlock: 'Bloqueado',
      overridesEmpty: 'Sem exceções: todas as unidades usam o valor global.',
      overridesDuplicate: 'Já existe uma exceção para «{{node}}». Os identificadores não diferenciam maiúsculas de minúsculas: edite ou remova a existente.',
      inboxTitle: 'Caixa de Reports',
      inboxDesc: 'Reports de utilizadores. Ao ocultar, o reconhecimento desaparece do mural de quem o recebeu e dos reconhecimentos enviados de quem o emitiu; também é removido do quadro de medalhas e cancela os pontos.',
      searchName: 'Procurar por nome…',
      filterAll: 'Todos',
      filterOu: 'OU: Todas',
      filterBu: 'BU: Todas',
      filterSite: 'Site: Todos',
      filterFrom: 'De',
      filterTo: 'Até',
      filterType: 'Tipo: Todas',
      type: { fundamentales: 'Fundamentais', brillamos: 'Brilhamos Juntos', diario: 'Reco Diário' },
      uiStatus: { pendiente: 'Pendente', restaurado: 'Restaurado', eliminado: 'Eliminado' },
      uiStatusPlural: { pendiente: 'Pendentes', restaurado: 'Restaurados', eliminado: 'Eliminados' },
      status: { Publicado: 'Publicado', Pendiente: 'Pendente', Resuelto: 'Resolvido', Desestimado: 'Descartado' },
      reportsEmpty: 'Nenhum report corresponde ao filtro.',
      colReportedBy: 'Reportado por',
      colRecognitionFrom: 'Reconhecimento de',
      colTo: 'Para',
      colDetail: 'Detalhe',
      colReason: 'Motivo',
      colDate: 'Data',
      colStatus: 'Estado',
      colActions: 'Ações',
      // RF-090 — botao envelope: encaminha o caso ao admin da OU/pais sem esperar o resumo semanal.
      notifyAdmin: 'Avisar o admin',
      notifyAdminHint: 'Envia agora um aviso ao administrador da unidade deste reconhecimento, sem esperar o resumo semanal.',
      notifyAdminConfirm: 'Enviar um aviso ao administrador da unidade de {{name}}? Um e-mail sai imediatamente.',
      notifyAdminSent: 'Aviso enviado ao administrador.',
      notifyAdminError: 'Não foi possível enviar o aviso ao administrador.',
      // RF-090 — pré-visualização dos destinatários: o ✉️ dizia «enviado» mesmo sem chegar a ninguém.
      notifyPreviewTitle: 'Este aviso chegará a:',
      notifyPreviewLoading: 'A resolver destinatários…',
      notifyPreviewEmpty: 'Nenhum destinatário foi resolvido.',
      notifyPreviewError: 'Não foi possível consultar a quem chegaria o aviso.',
      notifyReason: {
        'sin-admins-en-la-ou': 'Esta unidade não tem nenhum administrador registado, nem há administradores globais para escalar o caso.',
        'escalado-a-globales': 'A unidade não tem administrador próprio: o caso é escalado aos administradores globais.',
        'admin-sin-correo': 'O administrador não tem um e-mail utilizável no diretório, por isso não é possível escrever-lhe.',
        'directorio-no-responde': 'O diretório de utilizadores não respondeu: não se sabe a quem deveria chegar o aviso.',
        'suprimido-por-allowlist': 'O envio seria descartado: este endereço não está na lista de destinatários permitidos do serviço de notificações.',
        'allowlist-desconocida': 'Não foi possível verificar a lista de destinatários permitidos; o envio pode ser descartado sem deixar rasto.',
        desconocido: 'O aviso não pode ser enviado por um motivo que o serviço não soube explicar.',
      },
      deleteLabel: 'Eliminar',
      hideHint: 'Oculta o reconhecimento do mural, remove-o do quadro de medalhas e cancela seus pontos.',
      restore: 'Restaurar',
      reopen: 'Reabrir',
      reopenHint: 'Devolve o caso à fila como Pendente e oculta o reconhecimento novamente.',
      viewDetail: 'Ver detalhe',
      detailTitle: 'Detalhe do report',
      whoReported: 'Quem reportou',
      whoWasReported: 'Quem foi reportado',
      reportedRecognition: 'Reconhecimento reportado',
      messageUnavailable: 'Texto não disponível.',
      // RF-087 — encaminhamento do caso: e-mail e OU sempre aparecem, com marcador se faltarem.
      dataUnavailable: 'Não disponível',
      detailLoading: 'A carregar…',
      detailError: 'Não foi possível carregar os dados de contacto atualizados; mostram-se os guardados no momento do reporte.',
      chipOu: 'OU',
      chipBu: 'BU',
      chipSite: 'Site',
    },
    winners: {
      // Task 2.5 — grelha de cartões de Insígnias de Campanha em Ganhadores (AdminCampaignBadgeGrid).
      campaignBadges: {
        title: 'Insígnias de Campanha',
        permanenceNote: 'Estas insígnias são permanentes: não se ativam nem desativam como as de sequência; ficam associadas à campanha e ao ano em que foram atribuídas.',
        empty: 'Ainda não há insígnias de campanha.',
        edit: 'Editar',
        delete: 'Eliminar',
        deleteConfirm: 'Eliminar a insígnia de campanha «{{name}}»? Perde-se o nome nos 7 idiomas, o ícone e o ano. Esta ação não pode ser revertida.',
        add: '+ Adicionar insígnia',
        editTitle: 'Editar insígnia de campanha',
        fieldTitle: 'Título',
        fieldYearSubtitle: 'Ano / Subtítulo',
        fieldYear: 'Ano do prêmio',
        yearNone: 'Sem ano',
        fieldYearHint: 'Validado ao conceder: não se pode dar uma insígnia de um ano numa campanha de outro. "Sem ano" desativa a validação.',
        fieldImage: 'Imagem',
        imageUploadHintNew: 'Guarde a insígnia primeiro para poder enviar a sua imagem.',
        imageFormatInvalid: 'O formato de imagem não é válido. Utilize PNG, JPG, WEBP ou SVG.',
        previewTitle: 'Pré-visualização',
      },
      bulkTitle: 'Confirmação em lote',
      bulkSelected: '{{count}} selecionados',
      bulkConfirm: 'Confirmar {{count}}',
      bulkConfirming: 'A confirmar…',
      bulkClear: 'Retirar seleção',
      bulkSelectAll: 'Selecionar todos os pendentes desta página',
      bulkSelectOne: 'Selecionar {{name}}',
      bulkFailed: 'Não foi possível confirmar {{count}}. Os restantes foram confirmados; tente de novo só com esses.',
      editTitle: 'Editar vencedor — {{nombre}}',
      actionError: 'Não foi possível concluir a ação.',
      badExtension: 'Formato não suportado. São aceites: {{ext}}',
      // No son «Área»/«Site»: el backend resuelve esas dos columnas con el PUESTO y el
      // DEPARTAMENTO de la ficha de la persona (ver AdminWinners.tsx).
      colPuesto: 'Cargo',
      colDepto: 'Departamento',
      colFundamental: 'Fundamental',
      colStatus: 'Estado',
      colUser: 'Utilizador',
      colUserNomina: 'Número de matrícula: {{nomina}}',
      colYear: 'Ano',
      colBadge: 'Emblema',
      badgeNone: 'Sem emblema',
      exportFiltered: 'Descarrega em Excel os vencedores que os filtros atuais mostram',
      exportEmpty: 'Não há vencedores para exportar com estes filtros',
      exporting: 'A exportar…',
      exportTruncated: 'A descarga foi limitada a 5000 linhas. Afine os filtros para exportar o resto.',
      exportError: 'Não foi possível concluir a descarga. Tente de novo.',
      confirmAction: 'Confirmar como vencedor',
      confirmDelete1: 'Remover {{nombre}} da lista de vencedores?',
      confirmDelete2: 'Esta ação não pode ser anulada e fica registada. Confirma?',
      deleteTitle: 'Remover vencedor',
      deleteConfirm: 'Remover',
      countryAll: 'País: Todos',
      editAction: 'Editar',
      editClosed: 'Fora do período de edição.',
      editWindowNote: 'Pode editar um vencedor até 1 mês depois de o carregar. O Administrador Geral pode editar qualquer vencedor dos últimos 3 anos.',
      exportNominations: 'Exportar nomeações',
      exportWinners: 'Exportar vencedores',
      exportNominationsTruncated: 'A descarga foi limitada a 5000 linhas. Escolha uma campanha com menos nomeações ou tente novamente em partes.',
      exportNominationsEmpty: 'Não há nomeações para exportar nesta campanha.',
      exportPending: 'A exportação será ligada no próximo pacote.',
      filterCountry: 'País',
      filterFundamental: 'Fundamental',
      filterYear: 'Ano',
      filtersToggle: 'Filtros',
      flowHint: 'Os vencedores são carregados por ficheiro. O comportamento é: carregue o modelo → aparece aqui → confirma como vencedor final.',
      fundamentalAll: 'Fundamental: Todos',
      fundamentalNone: 'Sem fundamental',
      importErrorsTitle: 'Linhas rejeitadas',
      importSummary: '{{importados}} de {{total}} linhas importadas · {{rechazados}} rejeitadas.',
      manageTitle: 'Gestão de Vencedores',
      moduleHint: 'Ative para permitir o carregamento de vencedores e a atribuição de insígnias.',
      moduleOffWarn: 'Módulo de Vencedores desativado. Por agora, esta definição é apenas guardada e ainda não altera o que os utilizadores veem.',
      moduleSaveError: 'Não foi possível guardar a alteração do módulo de Vencedores. Tenta novamente.',
      moduleTitle: 'Módulo de Vencedores',
      needsCsv: 'É um livro de Excel binário e não pode ser lido. Abra-o e guarde-o como CSV (UTF-8) antes de carregar.',
      noResults: 'Sem vencedores que correspondam ao filtro.',
      ouAll: 'OU: Todas',
      pagerInfo: 'Página {{page}} de {{paginas}} · {{total}} vencedores',
      searchByName: 'Procurar por nome…',
      statusConfirmed: '✓ Confirmado',
      statusPending: '⏳ Pendente',
      uploadFile: 'Carregar Excel',
      uploadCampaign: 'Campanha do ficheiro',
      uploadMode: 'Edição do ficheiro',
      uploadModeCurrent: 'Vigente',
      uploadModeHistoric: 'Histórica',
      uploadOpen: 'Carregar registo',
      uploadOpenHint: 'Abre o assistente para carregar o registo de vencedores, vigente ou histórico.',
      uploadModalTitle: 'Carregar registo de vencedores',
      uploadModalToggleHint: 'Escolha "Vigente" se o registo pertence a uma campanha ativa no site. Escolha "Histórico" para carregar prémios de anos anteriores que não estão documentados como campanha.',
      uploadBadge: 'Insígnia',
      uploadBadgeHint: 'Todas as linhas do ficheiro vão receber ESTA insígnia. Escolha-a antes de carregar o ficheiro.',
      uploadBadgePick: 'Escolha a insígnia…',
      uploadBadgeClarify: 'A insígnia não é uma campanha: é a imagem que a pessoa vai ver como prémio conquistado (por exemplo, uma medalha ou um troféu).',
      pickBadgeFirst: 'Escolha primeiro a insígnia que os vencedores deste ficheiro vão receber.',
      uploadHistoricWarning: 'Os dados históricos são guardados diretamente, sem se ligarem a nenhuma campanha. Reveja nome, correio e insígnia antes de carregar.',
      helpOpen: 'Ajuda para carregar o registo',
      helpModalTitle: 'Como carrego o registo de vencedores?',
      helpIntroVigente: 'Vigente: utilize quando o prémio pertence a uma campanha que existe no site, ativa neste momento. Escolhe a campanha e a insígnia (a imagem que vão ver como prémio conquistado) e descarrega o modelo: só pede o e-mail ou número de funcionário da pessoa. O nome, o ano e a OU/local o sistema já os tem — não precisa de os escrever.',
      helpIntroHistorico: 'Histórico: utilize quando o prémio é de uma campanha antiga que já não existe no site, ou da qual não tem registo. NÃO escolhe campanha: em vez disso escolhe UMA insígnia (a imagem que vai ser mostrada como prémio conquistado, não o nome de uma campanha), que vai ser atribuída a TODAS as pessoas do ficheiro. Descarrega o modelo de 2 colunas (Nome e Correio ou Número de funcionário), preenche-o e carrega-o.',
      helpDirectorio: 'O correio ou o número de funcionário têm de existir no diretório da empresa. Se não encontrar nenhum dos dois, essa linha é rejeitada e o resto do ficheiro é carregado na mesma. Se a pessoa não tiver correio (por exemplo, pessoal de fábrica), escreva o número de funcionário nessa mesma coluna — não precisa do correio se já colocou o número de funcionário.',
      helpNoDownload: 'Se tentar descarregar um ficheiro e não houver nenhum dado para mostrar, não se descarrega nada: é avisado no ecrã.',
      downloadTemplateHint: 'Descarrega um Excel em branco com as colunas corretas para este modo, no seu idioma.',
      downloadTemplateCurrent: 'Descarregar modelo vigente',
      downloadTemplateHistoric: 'Descarregar modelo histórico',
      uploadFileHint: 'Carrega o Excel já preenchido com os dados do registo.',
      importWizard: {
        subtitle: 'Carrega o registo, revê o resultado antes de confirmar e descarrega os erros se algo falhar.',
        colNombreDesc: 'Nome do vencedor, tal como vai ser mostrado.',
        colNombreDescVigente: 'Nome do vencedor. Pode deixar em branco: se não o escrever, é usado o nome que a pessoa já tem registado na empresa.',
        colEmailDesc: 'E-mail OU número de funcionário da pessoa — basta um dos dois; identifica quem recebe o prémio.',
        colFundamentalDesc: 'Fundamental reconhecido (nome em qualquer idioma ou código do catálogo). Ignorado se não corresponder a nenhum.',
        badgePreviewHint: 'É assim que a insígnia aparece — exatamente o que cada vencedor deste ficheiro vai receber.',
        dropHint: 'Arrasta o teu ficheiro Excel ou CSV para aqui, ou clica para o escolher.',
        reviewHint: 'Isto é só uma VALIDAÇÃO: ainda não se guarda nada. Revê o resumo e, se for preciso, volta atrás para escolher um ficheiro corrigido.',
        previewPending: 'A validar ficheiro…',
        noErrors: 'Sem erros — todas as linhas são válidas.',
        fileLevelError: 'Ficheiro/seleção',
        confirmPending: 'A guardar…',
      },
      filterEstado: 'Estado',
      estadoAll: 'Estado: Todos',
      uploadCampaignPick: 'Escolhe a campanha…',
      pickCampaignFirst: 'Escolhe primeiro a campanha a que pertence o ficheiro.',
      exportNominationsCatalogError: 'Não foi possível carregar o catálogo de Fundamentais/Hábitos: a exportação pode sair incompleta. Tenta novamente.',
      yearAll: 'Ano: Todos',
      desc: 'Registro de vencedores de Brilhamos Juntos.',
      title: 'Vencedores',
      descLong: 'Vencedores por campanha/OU. Criação manual e importação CSV do histórico com feedback por linha.',
      filterCampaign: 'Campanha',
      campaignIdHint: 'Id da campanha',
      filterOu: 'OU',
      ouHint: 'Id da OU',
      add: 'Adicionar vencedor',
      addTitle: 'Novo vencedor',
      fieldCampaign: 'Campanha',
      fieldUser: 'Utilizador',
      fieldName: 'Nome',
      fieldOuName: 'OU',
      fieldCountry: 'País',
      fieldPosition: 'Posição',
      save: 'Guardar',
      importTitle: 'Importação CSV',
      importHint: 'Descarregue o modelo, preencha-o e envie-o. A importação é idempotente por campanha + utilizador.',
      downloadTemplate: 'Descarregar modelo',
      uploadCsv: 'Enviar CSV',
      templateError: 'Não foi possível descarregar o modelo.',
      importError: 'Não foi possível processar a importação.',
      deleteError: 'Não foi possível remover este vencedor.',
      totalRows: 'Linhas totais',
      imported: 'Importados',
      rejected: 'Rejeitados',
      row: 'Linha',
      reason: 'Motivo',
      empty: 'Não há vencedores para os filtros.',
      colPosition: 'Posição',
      colName: 'Nome',
      colOu: 'OU',
      colCountry: 'País',
      colCrossed: 'Origem cruzada',
      colDate: 'Registrado',
      // Task 16 — cabeçalhos da exportação bruta de nomeações (i18n, já não espanhol fixo).
      nominationsExport: {
        // As chaves `nominee*` contêm a pessoa que NOMEOU (o bloco Nominee_* do DTO vem de
        // Recognition.EmisorSnapshot). A pessoa nomeada é o bloco `candidate*` abaixo.
        nomineeName: 'Nomeador: Nome',
        nomineeEmail: 'Nomeador: E-mail',
        nomineeEmployeeId: 'Nomeador: Nº funcionário',
        nomineeOu: 'Nomeador: OU',
        nomineeBu: 'Nomeador: BU',
        nomineeSite: 'Nomeador: Site',
        nomineeDepartment: 'Nomeador: Cargo',
        onBehalfOfName: 'Em nome de: Nome',
        onBehalfOfEmail: 'Em nome de: E-mail',
        onBehalfOfEmployeeId: 'Em nome de: Nº funcionário',
        onBehalfOfOu: 'Em nome de: OU',
        onBehalfOfBu: 'Em nome de: BU',
        onBehalfOfSite: 'Em nome de: Site',
        onBehalfOfDepartment: 'Em nome de: Cargo',
        candidateName: 'Candidato: Nome',
        candidateEmail: 'Candidato: E-mail',
        candidateEmployeeId: 'Candidato: Nº funcionário',
        candidateOu: 'Candidato: OU',
        candidateBu: 'Candidato: BU',
        candidateSite: 'Candidato: Site',
        candidateDepartment: 'Candidato: Cargo',
        date: 'Data',
        year: 'Ano',
        month: 'Mês',
        habitPrefix: 'Hábito',
        comment: 'Comentário',
        streakBadge: 'Insígnia de sequência',
        fromDayToDay: 'Vem do dia a dia',
        status: 'Estado',
        type: 'Tipo',
        audienceNominee: 'Audiência do nomeador',
        audienceCandidate: 'Audiência do candidato',
        points: 'Pontos',
        retiredHabitsGroup: 'Outros / hábitos retirados',
      },
    },
    campaigns: {
      desc: 'Assistente de campanhas de reconhecimento.',
      statusDivider: 'Estado das campanhas',
      title: 'Campanhas',
      descLong: 'Lista de campanhas e assistente de 5 passos: Info, Público, Configuração, Documentos e Publicação.',
      filterAll: 'Todas',
      status: {
        Borrador: 'Rascunho', Activa: 'Ativa', Finalizada: 'Encerrada', PendienteAprobacion: 'Pendente de aprovação',
        // Bug UAT #114 — «Activa» significaba dos cosas: corriendo, o marcada activa
        // pero fuera de su ventana de fechas (el colaborador no la ve).
        ActivaVencida: 'Ativa · fora do período',
        ActivaPorIniciar: 'Ativa · ainda não iniciou',
        ActivaVencidaHint: 'A campanha continua marcada como ativa, mas o seu período terminou: os colaboradores do seu alcance não a veem.',
        ActivaPorIniciarHint: 'A campanha está ativa mas a data de início ainda não chegou.',
      },
      approvals: 'Aprovações',
      new: 'Nova campanha',
      empty: 'Não há campanhas.',
      colName: 'Nome',
      colType: 'Tipo',
      colStatus: 'Estado',
      colScope: 'Alcance',
      allScopes: 'Todas as OUs',
      editBtn: 'Editar',
      duplicate: 'Duplicar',
      panic: 'Parar Campanha',
      deactivateConfirmTitle: 'Parar exceção por OU',
      deactivateConfirmMsg: 'Parar esta exceção por OU agora? Deixará de se aplicar ao seu âmbito de imediato.',
      panicConfirm: 'Parar esta campanha imediatamente?',
      type: { Fundamentales: 'Fundamentais', Brillamos: 'Brilhamos', Personalizada: 'Personalizada' },
      wizardEditTitle: 'Editar campanha',
      wizardNewTitle: 'Nova campanha',
      wizardSub: 'Complete os 6 passos para criar ou editar a campanha.',
      backToList: 'Voltar à lista',
      step: { info: 'Info', design: 'Design', audience: 'Público', config: 'Configuração', documents: 'Documentos', publish: 'Publicar' },
      tabFundamentales: 'Fundamentais',
      tabBrillamos: 'Shine Together',
      tabPersonalizadas: 'Personalizadas',
      fundActiveTitle: 'Sempre Ativo',
      fundRules: 'Regras de envio',
      fundActiveDesc: 'Fundamentais é a base do programa de reconhecimento. Não pode ser desativado, apenas configurar as suas regras.',
      fundConfigNote: 'As regras de envio e os limites detalhados são geridos na secção Gestão.',
      globalPanic: 'Parar Todas as Campanhas',
      globalPanicConfirm: 'Encerrar imediatamente TODAS as campanhas Shine Together ativas? Esta ação não pode ser desfeita.',
      globalPanicDone: '{{count}} campanha(s) encerrada(s).',
      docCategoria: 'Categoria',
      docCatNone: 'Sem categoria',
      fieldType: 'Tipo de campanha',
      fieldName: 'Nome',
      fieldDescription: 'Descrição',
      fieldSlug: 'Slug da landing',
      fieldScope: 'Alcance (OUs)',
      fieldExclusions: 'Exclusões',
      fieldStart: 'Data de início',
      fieldEnd: 'Data de término',
      fieldTimezone: 'Fuso horário',
      fieldStreakMinimum: 'Mínimo de sequência da campanha',
      streakMinimumInherit: 'Usar o global',
      streakMinimumHint: 'Envios que esta campanha exige para somar sequência no período (1-20). Vazio = aplica-se o mínimo global da Gestão.',
      streakMinimumLocked: 'A campanha já começou: o mínimo de sequência não pode mudar sem requalificar o período em curso.',
      fieldRecognitionsLimitOwn: 'Limite de envios da campanha',
      recognitionsLimitOwnInherit: 'Usa o global',
      recognitionsLimitNotApplicable: 'Não se aplica (sem limite de envios)',
      recognitionsLimitNotApplicableShort: 'Sem limite',
      fieldSameFundamentalLimit: 'Vezes mesmo fundamental à mesma pessoa',
      sameFundamentalInherit: 'Usa o global',
      sameFundamentalNotApplicable: 'Não se aplica (sem limite)',
      sameFundamentalNotApplicableShort: 'Sem limite',
      recognitionsLimitOwnHint: 'Reconhecimentos que esta campanha permite por período. Vazio = aplica-se o limite global de Gestão. Editável a qualquer momento, mesmo com a campanha já ativa.',
      fieldWrappedRelease: 'Lançamento do Wrapped',
      wrappedReleaseOnFinish: 'Ao encerrar a campanha',
      wrappedReleaseHint: 'Dia em que o Wrapped fica visível para o alcance desta campanha, no seu próprio fuso horário. Vazio = é liberado quando a campanha passar a Finalizada.',
      visibility: 'Visibilidade',
      visSender: 'Mostrar remetente',
      visFundamental: 'Mostrar fundamental',
      visText: 'Mostrar texto',
      visHabit: 'Mostrar hábito',
      visSent: 'Contador de enviados',
      visReceived: 'Contador de recebidos',
      visAnonymous: 'Permitir anónimos',
      visBulk: 'Carga em massa CSV',
      visReactions: 'Reações (👏❤️😊🎉👍)',
      visCampaignTag: 'Mostrar etiqueta da campanha',
      visFromFundamentals: 'Permitir envio a partir dos Fundamentais',
      visSendingDisabled: 'Desativar envio de reconhecimentos',
      anonymousOverrideLabel: 'Reconhecimentos anónimos',
      anonymousOverrideInherit: 'Herdar de Gestão',
      anonymousOverrideAllow: 'Permitir',
      anonymousOverrideDeny: 'Não permitir',
      anonymousOverrideHint: 'Aplica-se APENAS a esta campanha. Deixado em "Herdar de Gestão", esta campanha usa a configuração global.',
      points: 'Pontos',
      pointsLocked: 'Os pontos são imutáveis: a campanha já começou.',
      pointsHint: 'Somente Europa; o frontend nunca mostra os pontos.',
      applyPoints: 'A campanha concede pontos',
      brillamosRecurringDesc: 'Campanha recorrente de nomeação por Fundamentos.',
      paisScheduleTitle: 'Horários e Datas por País',
      paisScheduleIntro: 'Configure horários ou datas diferentes por país. Se não for definido, herda o global.',
      paisCol: 'País',
      paisOpen: 'Horário de abertura',
      paisClose: 'Horário de fecho',
      paisActive: 'Ativo',
      paisApplySchedule: 'Aplicar horário',
      paisClearHours: 'Limpar horário',
      paisOverrideBadge: 'Campanha de UO',
      paisOverrideWins: 'Tem preferência sobre esta linha: {{alcance}}.',
      paisOverrideNoSend: 'Envio desativado',
      paisOverrideDates: 'Datas {{inicio}} → {{fin}}',
      paisOverrideHours: 'Horário {{inicio}}–{{fin}}',
      paisScheduleNoActive: 'Não existe nenhuma campanha Brillamos Juntos ativa: os horários por país configuram-se na campanha em vigor. Ative uma campanha para os registar.',
      saveDraftFirst: 'Guarde o rascunho para gerir seus documentos.',
      saveDraft: 'Guardar rascunho',
      saveDraftLater: 'O rascunho é guardado ao terminar a configuração. Use «Próximo» para avançar pelos passos.',
      dates: 'Datas',
      publishRequirements: 'Requer nome nos 7 idiomas, ao menos uma OU de alcance e datas de início e fim. Guardar fica ativo ao completar a configuração.',
      valNameAllLangs: 'Informe o nome nos 7 idiomas.',
      valScope: 'Selecione pelo menos uma unidade organizacional no alcance.',
      scopeConflict: "Estas unidades já estão numa campanha ativa: {{campanas}}. Retire-as do alcance ou termine essa campanha.",
      valScopeConflict: "O alcance entra em conflito com uma campanha ativa: {{campanas}}.",
      scopeConflictPartial: "Existem mais campanhas ativas do que as que foi possível rever: a verificação de conflitos pode estar incompleta.",
      scopeEmpty: "Não tem unidades organizacionais no seu âmbito para criar campanhas. Peça a um administrador global que lhe atribua um âmbito.",
      outOfScopeHint: "Esta campanha inclui unidades organizacionais fora do seu âmbito: só a pode editar um administrador que as abranja todas.",
      valScopeExcludesOwn: "Não pode excluir a sua própria unidade organizacional do alcance.",
      valStart: 'Informe a data de início da campanha.',
      valEnd: 'Informe a data de término da campanha.',
      valTimezone: 'Selecione o fuso horário da campanha.',
      valDateOrder: 'A data de término deve ser posterior à data de início.',
      designMenu: 'Ícone e título no menu lateral',
      designMenuHint: 'É assim que a campanha aparecerá na barra lateral da plataforma para os utilizadores.',
      designIcon: 'Ícone',
      designMenuTitle: 'Título do menu',
      designMenuTitlePh: 'ex.: Inovação LATAM',
      designSections: 'Seções da landing',
      designSectionsHint: 'O banner e o formulário de indicação estão sempre presentes. Ative as seções opcionais.',
      designShowStreak: 'Sequência de reconhecimentos',
      designShowRecent: 'Reconhecimentos recentes',
      designBrillamosLocked: 'A identidade do Shine Together é imutável: seu design não pode ser editado.',
      approvalSent: 'Solicitação de aprovação enviada.',
      submitApproval: 'Enviar para aprovação',
      submitApprovalConfirmTitle: 'Enviar para aprovação',
      submitApprovalConfirmMsg: 'Enviar esta campanha para aprovação? O Admin General terá de a rever antes de ficar ativa.',
      prev: 'Anterior',
      next: 'Próximo',
      docLang: 'Idioma',
      docUrl: 'URL do documento',
      docTitle: 'Título',
      addDoc: 'Adicionar documento',
      docCategoryRequired: 'Seleciona uma categoria antes de adicionar o documento.',
      docTitleRequired: 'Completa o título nos 7 idiomas antes de adicionar o documento.',
      docsEmpty: 'Não há documentos.',
      docsFallbackNote: 'Se não forem carregados documentos aqui, esta campanha mostra os da secção Documentação da administração.',
      approvalsTitle: 'Aprovações pendentes',
      approvalsSub: 'Campanhas que aguardam sua aprovação (AdminGlobal).',
      approvalsEmpty: 'Não há aprovações pendentes.',
      colCampaign: 'Campanha',
      requestedBy: 'Solicitada por',
      approve: 'Aprovar',
      approveConfirmTitle: 'Aprovar campanha',
      approveConfirmMsg: 'Aprovar esta campanha? Ficará ativa e visível para o seu âmbito.',
      reject: 'Rejeitar',
      rejectReason: 'Motivo da rejeição (obrigatório)',
      rejectConfirm: 'Confirmar rejeição',
      viewDetail: 'Ver detalhe',
      bannerDesign: 'Design do banner',
      bannerScopeLabel: 'Este banner aplica-se apenas a esta campanha; se não for configurado, herda o banner global do programa.',
      bannerDesignHint: 'Troque o idioma acima para editar título, subtítulo e logo desse idioma — a pré-visualização é atualizada ao vivo.',
      bannerTitle1: 'Título (linha 1)',
      bannerTitle2: 'Título (linha 2)',
      bannerSubtitle: 'Subtítulo',
      bannerLogoNote: 'O upload da imagem do logo (PNG por idioma) estará disponível em breve.',
      bannerLogo: 'Logo (imagem para este idioma)',
      bannerLogoUpload: 'Enviar PNG',
      bannerLogoReset: 'Voltar ao padrão',
      bannerLogoHint: 'Recomendado: PNG transparente ~4:3. Por padrão é exibido o logo de Fundamentals.',
      bannerLogoErrPng: 'O logo deve ser um PNG.',
      bannerLogoErrSize: 'O PNG não deve exceder 500 KB.',
      bannerPreview: 'Pré-visualização',
      bannerPreviewEmpty: 'Título do banner',
      bannerCta: 'Reconhecer alguém',
      brillamosBannerTitle: 'Banner do Brilhamos Juntos',
      brillamosBannerHint: 'Personalize o subtítulo e o logotipo do herói do Brilhamos Juntos por idioma. A pré-visualização é atualizada em tempo real.',
      brillamosBannerLogoHint: 'Recomendado: PNG transparente. Por padrão é exibido o logotipo Shine.',
      entryPoints: 'Modalidade de reconhecimento (entry points)',
      entry: { A: 'Entry A — Formulário clássico', B: 'Entry B — Post-it interativo (Word Builder)', both: 'Ambos visíveis (teste A/B)' },
      commentRequired: 'Comentário obrigatório',
      vista: 'Visão:',
      vistaGlobal: 'Admin Global',
      vistaOu: 'Admin OU / Embaixador',
      rulesTitle: 'Regras de Envio',
      brillamosRulesIntro: 'Estas regras aplicam-se apenas a Shine Together. Um campo em branco herda o valor global da Gestao.',
      ruleMultiPersona: 'Multi-pessoa',
      ruleMultiFundamental: 'Multi-fundamental',
      ruleBulkCsv: 'Carga em massa CSV',
      ruleReactions: 'Reações no mural',
      ruleSendingDisabled: 'Desativar envio',
      ruleAnonymousEnabled: 'Permitir reconhecimentos anónimos',
      anonymousGestionHint: 'Aplica-se a tudo (Fundamentais, Brillamos e campanhas personalizadas), salvo se uma campanha definir a sua própria configuração no passo Configuração do assistente. Não afeta a anonimização automática por RGPD na Europa.',
      ruleMinChars: 'Mín. caracteres',
      moderationTitle: 'Moderação',
      modPostEdit: 'Edição pós-envio',
      moderationNote: 'O botão Reportar e o Filtro de palavras são geridos na secção Moderação.',
      resetToGlobal: 'Repor (herdar do global)',
      streakTitle: 'Configuração de Sequência (Fundamentos)',
      streakActive: 'Sequência ativa',
      streakSentNote: 'A sequência é calculada pelos reconhecimentos ENVIADOS.',
      streakInProfile: 'Mostrar sequência no perfil',
      badgesActive: 'Insígnias ativas',
      streakPeriod: 'Período',
      periodWeekly: 'Semanal',
      periodMonthly: 'Mensal',
      periodDaily: 'Diário',
      limitsTitle: 'Limites (Gestão de Limites)',
      limitsActive: 'Limites ativos',
      limitName: 'Nome',
      limitDescription: 'Descrição',
      limitRecognitionsDesc: 'Máximo de reconhecimentos',
      limitFundamentalsDesc: 'Máximo selecionáveis por envio',
      limitValue: 'Limite',
      limitFrequency: 'Frequência',
      limitActiveCol: 'Ativo',
      limitRecognitions: 'Reconhecimentos por período',
      limitFundamentals: 'Fundamentais por rec.',
      perSubmission: 'Por envio',
      readonlyTitle: 'Configuração Geral — Fundamentais (aplicada por padrão)',
      readonlyBadge: 'Somente leitura',
      readonlyNote: 'Se quiser adicionar uma exceção por OU, ela passará pela aprovação do Admin Global.',
      colDate: 'Data',
      exc: {
        title: 'Exceções por OU',
        intro: 'Exceções pontuais à configuração base para um alcance OU/BU/Site específico. Cada uma passa pela aprovação do Admin Global.',
        new: 'Nova exceção por OU',
        colException: 'Exceção',
        colScope: 'OU / BU / Site',
        colState: 'Estado da Campanha',
        fullOu: 'Toda a OU',
        sites: '{{count}} sites',
        scopePopTitle: 'Sites do alcance',
        stateActive: 'Ativa',
        stateInactive: 'Inativa',
        toggleHint: 'Apenas uma exceção aprovada pode ser ativada ou desativada.',
        edit: 'Editar',
        delete: 'Eliminar',
        empty: 'Ainda não há exceções por OU.',
        deleteTitle: 'Eliminar exceção',
        deleteMsg: 'Esta exceção por OU será removida permanentemente. Esta ação não pode ser desfeita.',
        deleteConfirm: 'Eliminar',
        summaryTope: 'Limite: {{max}} recos / {{freq}}',
        summaryDisable: 'Desativar envio',
        disableTitle: 'Desativar envio (override)',
        disableNote: 'Bloqueia temporariamente o envio de reconhecimentos para o alcance selecionado, sem desativar o programa. Requer aprovação do Admin Global.',
        summarySchedule: 'Horário restrito',
        summaryVisibility: 'Visibilidade',
        summaryBanner: 'Banner',
        approvalsTitle: 'Aprovações',
        approvalsColSolicitante: 'Solicitante',
        approvalsColAprobador: 'Aprovador',
        approvalsColFecha: 'Data',
        approvalsColEstado: 'Estado',
        approved: 'Aprovada',
        pending: 'Pendente',
        rejected: 'Rejeitada',
        approvalsEmpty: 'Ainda não há exceções para aprovar.',
        pendingBanner: 'Tem {{count}} exceção(ões) a aguardar a sua aprovação.',
        approve: 'Aprovar',
        reject: 'Rejeitar',
        rejectReason: 'Motivo da rejeição (obrigatório)',
        rejectConfirm: 'Confirmar rejeição',
        back: 'Exceções por OU',
        wizardTitle: 'Exceção por OU — Fundamentos',
        wizardTitleBrillamos: 'Exceção por OU — Brilhamos Juntos',
        stepScope: 'Alcance',
        stepSchedule: 'Horários',
        stepBanner: 'Banner',
        // Bug UAT #114 — la «campaña por OU» sobreescribe una campaña activa; sin una debajo no hace nada.
        baseCampaignTitle: 'Campanha base',
        baseCampaignHint: 'Uma exceção por OU não funciona sozinha: SOBREPÕE partes de uma campanha ativa para o seu alcance. Se não houver uma campanha ativa que cubra essas OUs, esta exceção não terá qualquer efeito. Se precisa de uma campanha própria e completa para a OU, tem de a criar em Campanhas, não aqui.',
        baseCampaignLabel: 'Campanha que é sobreposta',
        baseCampaignNone: 'Sem indicar (aplica-se à campanha ativa que cubra o alcance)',
        baseCampaignNinguna: 'Não existe nenhuma campanha de Brilhamos Juntos ativa. Crie e ative uma primeiro, ou esta exceção não se aplicará a ninguém.',
        baseCampaignRequerida: 'Escolha a campanha base para poder guardar: sem ela a exceção não se aplicaria a ninguém.',
        baseCampaignVentana: 'A campanha base vai de {{inicio}} a {{fin}}. Estas datas são da campanha e não se editam aqui.',
        baseCampaignSinVentana: 'A campanha base não tem período de vigência definido.',
        scheduleWindow: 'Data e hora locais da exceção',
        scheduleStart: 'Início da exceção',
        scheduleEnd: 'Fim da exceção',
        scheduleTz: 'Fuso horário',
        scheduleRestrictTitle: 'Desativar reconhecimentos',
        scheduleRestrictNote: 'Quando ativo, não é possível enviar reconhecimentos fora da data e hora configuradas para este alcance. Requer aprovação do Admin Global.',
        scheduleWindowNota: 'Se definir uma janela, os envios deste alcance ficarão restritos a ela. Deixe-a vazia para não restringir nada.',
        scheduleInvalid: 'A janela de horário requer data/hora de início e fim, e o fim deve ser posterior ao início.',
        bannerTitle: 'Banner do Brilhamos Juntos (exceção)',
        bannerIntro: 'Substitui o subtítulo e o logótipo do banner do Brilhamos Juntos apenas para o alcance desta exceção. Se não editar nenhum idioma aqui, mantém-se o banner global.',
        bannerScopeLabel: 'Este banner aplica-se apenas ao alcance desta exceção, não ao banner global do Brilhamos Juntos.',
        stepDocs: 'Documentos',
        stepVisibility: 'Visibilidade',
        scopeIntro: 'Defina o alcance organizacional.',
        docsIntro: 'Anexe documentos específicos para esta exceção por OU.',
        entryPoints: 'Entry Points',
        entryPointMode: 'Portas de envio habilitadas (override)',
        entryPointModeApp: 'Apenas formulário',
        entryPointModePostit: 'Apenas post-it interativo',
        entryPointModeAmbos: 'Ambas',
        visTitle: 'Visibilidade do reconhecimento (override)',
        visIntro: 'Configure quais informações são mostradas ao utilizador ao receber ou consultar um reconhecimento.',
        visText: 'Mostrar texto/comentário do reconhecimento',
        visFundamental: 'Mostrar fundamento atribuído',
        visSender: 'Mostrar nome do remetente',
        visHabit: 'Mostrar Daily Habit selecionado',
        visRanking: 'Mostrar ranking de outras OUs',
        visMultiFund: 'Permitir múltiplos Fundamentos por reconhecimento',
        maxFundamentales: 'Máx. Fundamentos por reconhecimento',
        rulesTitle: 'Regras de envio (override)',
        ruleMultiPersona: 'Multi-pessoa',
        ruleComment: 'Comentário obrigatório',
        ruleMinChars: 'Mín. caracteres',
        ruleCsv: 'Upload CSV',
        modTitle: 'Moderação (override)',
        modReport: 'Botão Reportar',
        modEditDelete: 'Botões Editar e Eliminar (apenas enviados)',
        streakTitle: 'Sequência (override)',
        streakMin: 'Mín. envios/semana',
        streakPeriod: 'Período',
        limitsTitle: 'Limites (override)',
        limitMax: 'Máx. recos',
        limitFreq: 'Frequência',
        approvalRequiredTitle: 'Aprovação necessária',
        approvalRequiredMsg: 'Todas as alterações deverão ser aprovadas pelo Admin Global antes de serem aplicadas.',
      },
      // C2/P17 — Frecuencia declarativa; el vocabulario sale del Excel del cliente.
      fieldFrecuencia: 'Frequencia',
      frecuenciaPlaceholder: 'Ex. Mensal, A cada 3 reunioes…',
      frecuencia: {
        mensual: 'Mensal',
        trimestral: 'Trimestral',
        cadaNReuniones: 'A cada 3 reunioes',
        porEvento: 'Por evento',
      },
      // C2/P18-bis — deshacer un panico accidental (24 h, misma OU libre).
      undoPanic: 'Reativar campanha',
      undoPanicConfirm: 'Esta campanha sera reativada e voltara a estar visivel no seu ambito. So e possivel nas 24 h seguintes. Continuar?',
      // C2/P19 — meta de participantes; la ayuda repite la DEFINICIÓN a propósito.
      fieldMetaParticipantes: "Meta de participantes",
      metaParticipantesInherit: "Sem meta",
      metaParticipantesHelp: "Pessoas distintas que participem, reconhecendo ou sendo reconhecidas. Vazio = sem meta.",
      tooltip: {
        entryPoints: 'Como as pessoas podem reconhecer alguém: formulário clássico, post-it interativo, ou ambos ao mesmo tempo.',
        ruleMultiPersona: 'Permite incluir mais do que uma pessoa como destinatário no mesmo reconhecimento.',
        ruleMultiFundamental: 'Permite marcar mais do que um Fundamental no mesmo reconhecimento.',
        commentRequired: 'Exige a redação de um comentário para poder enviar o reconhecimento.',
        ruleBulkCsv: 'Ativa o carregamento em massa de reconhecimentos por ficheiro CSV.',
        ruleReactions: 'Permite que outras pessoas reajam com emojis a um reconhecimento.',
        ruleSendingDisabled: 'Desliga por completo o envio de reconhecimentos para este âmbito, sem afetar os já enviados.',
        ruleAnonymousEnabled: 'Permite enviar um reconhecimento sem mostrar o nome de quem o envia.',
        modPostEdit: 'Permite editar um reconhecimento já enviado, dentro da janela de edição.',
        antiSpoiler: 'Oculta reconhecimentos recentes na Home para não revelar surpresas antes do encerramento.',
        streakActive: 'Ativa a contagem da sequência semanal de reconhecimentos para esta campanha.',
        dailyHabitsMandatory: 'Exige marcar um hábito diário para que o reconhecimento conte para a sequência.',
        streakInProfile: 'Mostra a sequência atual no perfil público do utilizador.',
        badgesActive: 'Ativa a atribuição de insígnias por cumprir metas de sequência.',
        limitsActive: 'Ativa os limites de envio configurados abaixo, por reconhecimentos e por Fundamentais.',
        recognitionsLimitActive: 'Aplica o limite de reconhecimentos por período a este âmbito.',
        recognitionsLimitDisabled: 'Marque «Não se aplica» para que esta campanha NÃO tenha limite total de envios: a pessoa pode enviar os reconhecimentos que quiser no período, independentemente do limite global da Gestão. Deixe sem marcar (e o campo vazio) para usar o limite global.',
        streakMinimum: 'Mínimo de reconhecimentos que uma pessoa deve ENVIAR no período para que este conte para a sua sequência (1-20). Sobrepõe o mínimo global da Gestão apenas para esta campanha; vazio = aplica-se o global. Não pode ser alterado com a campanha já iniciada.',
        recognitionsLimitOwn: 'Máximo TOTAL de reconhecimentos que uma pessoa pode enviar no período (a quem for, de qualquer fundamental). Sobrepõe o limite global da Gestão apenas para esta campanha; vazio = aplica-se o global. Editável a qualquer momento, mesmo com a campanha iniciada.',
        sameFundamentalLimit: 'Quantas VEZES uma pessoa pode reconhecer outra sobre o MESMO fundamental no período (à mesma pessoa). Sobrepõe o valor global da Gestão apenas para esta campanha; vazio = aplica-se o global. Na Europa mantém-se o mínimo legal (RGPD).',
        sameFundamentalLimitDisabled: 'Marque «Não se aplica» para permitir repetir o mesmo fundamental à mesma pessoa SEM limite, independentemente do global. Deixe sem marcar (e o campo vazio) para usar o global. Na Europa o limite legal mantém-se mesmo que marque.',
        fundamentalsLimitActive: 'Aplica o limite de Fundamentais por envio a este âmbito.',
        designShowStreak: 'Mostra o bloco de sequência na landing page desta campanha.',
        designShowRecent: 'Mostra os reconhecimentos recentes na landing page desta campanha.',
        visSender: 'Mostra o nome de quem envia o reconhecimento.',
        visFundamental: 'Mostra o Fundamental atribuído no reconhecimento.',
        visText: 'Mostra o texto ou comentário do reconhecimento.',
        visHabit: 'Mostra o Daily Habit selecionado, se aplicável.',
        visSent: 'Mostra o separador de reconhecimentos enviados.',
        visReceived: 'Mostra o separador de reconhecimentos recebidos.',
        visBulk: 'Ativa o carregamento em massa por CSV apenas para esta campanha.',
        visReactions: 'Ativa as reações com emoji apenas para esta campanha.',
        visCampaignTag: 'Mostra a etiqueta com o nome da campanha em cada post-it.',
        visFromFundamentals: 'Permite iniciar este reconhecimento a partir do ecrã de Fundamentais.',
        visSendingDisabled: 'Desliga o envio de reconhecimentos apenas para esta campanha.',
        applyPoints: 'Os reconhecimentos desta campanha atribuem pontos trocáveis. Não é possível desligar depois de a campanha já ter começado.',
        visRanking: 'Mostra o ranking comparado com outras OUs.',
        visMultiFund: 'Permite marcar mais do que um Fundamental, como exceção desta OU.',
        modReport: 'Permite denunciar um reconhecimento inadequado.',
        modEditDelete: 'Ativa editar e eliminar um reconhecimento já enviado, apenas para esta OU. O backend trata ambas as permissões como um único interruptor.',
        scheduleEnabled: 'Restringe o envio de reconhecimentos à janela horária definida acima.',
        disableSend: 'Bloqueia o envio de reconhecimentos para este âmbito específico.',
        paisActive: 'Se estiver desligado, a campanha deixa de estar ativa para este país, mesmo que a data e o horário configurados ainda estejam em vigor.',
        paisApplySchedule: 'Se estiver desligado, a data e o horário desta linha ficam guardados mas NÃO se aplicam: o país não tem restrição de horário. Serve para deixar uma janela preparada e ligá-la mais tarde sem a registar de novo.',
      },
      tooltipAria: 'Ajuda',
    },
    reports: { desc: 'Relatórios e analytics do programa.' },
    translate: {
      button: 'Traduzir para os demais idiomas',
      buttonFrom: 'Traduzir de {{lang}} para os demais idiomas',
      loading: 'A traduzir…',
      hint: 'Preencha ao menos um idioma para traduzir.',
      error: 'Não foi possível traduzir automaticamente.',
      sessionExpired: 'A sessão expirou. Recarregue a página e inicie sessão novamente.',
    },
    misSolicitudes: {
      title: "Os meus pedidos de campanha",
      desc: "O estado do que propôs. Pode retirar um pedido enquanto estiver pendente e voltar a enviá-lo se tiver sido recusado.",
      empty: "Ainda não enviou nenhum pedido.",
      colCampana: "Campanha",
      colFecha: "Data do pedido",
      colEstado: "Estado",
      colComentario: "Comentário",
      colAcciones: "Ações",
      editar: "Editar",
      retirar: "Retirar pedido",
      reenviar: "Voltar a enviar",
      estado: {
        pendiente: "Pendente",
        aprobada: "Aprovado",
        rechazada: "Recusado",
      },
    },
    management: {
      desc: 'Regras de envio, limites e sequência.',
      title: 'Gestão',
      descLong: 'Ajustes globais: descrição de sequência ×7, insígnias, chaves globais e freeze. Guardado atómico.',
      fixValidation: 'Corrija as validações antes de guardar.',
      streakDescription: 'Descrição da sequência',
      fundamentalsTitle: 'Fundamentais disponíveis',
      fundamentalsDesc: 'Que Fundamentais são oferecidos ao reconhecer. Retirar um não o apaga do catálogo: deixa de aparecer neste programa.',
      fundamentalsLastOne: 'É o último disponível: se o retirar, ninguém conseguiria enviar um reconhecimento.',
      avatarTitle: 'Configuração de Avatar (Frontline)',
      avatarDesc: 'Os utilizadores frontline que entram pela webapp podem personalizar um avatar de cor. Quem entra pelo Teams mantém a sua fotografia de perfil.',
      avatarEnabled: 'Avatar personalizável ativo',
      avatarSelector: 'Mostrar seletor após o registo',
      avatarColors: 'Cores disponíveis:',
      placeholderTitle: 'Descrição configurável do campo de texto',
      placeholderDesc: 'O texto de ajuda do campo de mensagem ao reconhecer. Cada idioma que deixar vazio usa o texto predefinido do produto.',
      placeholderLabel: 'Texto de ajuda da mensagem',
      panicTitle: 'Botão de Pânico — Brillamos Juntos',
      panicDesc: 'Desativa de imediato o envio de reconhecimentos em todas as campanhas ativas. Aplica-se tanto a Shine Together como a Reconhecer (Fundamentais). Apenas Admin Geral.',
      panicToggle: 'Kill Switch Global Brillamos',
      panicActiveHint: 'O envio está DESATIVADO: ninguém pode enviar reconhecimentos neste momento.',
      panicSameSwitchHint: 'É um interruptor global: enquanto estiver ativo, nenhuma configuração por programa ou por campanha pode reativar o envio.',
      panicNoActiveCampaign: 'Este interruptor fica disponível quando existe pelo menos uma campanha Shine Together ativa (RN-C08). Neste momento não existe nenhuma, pelo que não há envios de campanha para parar.',
      needAllLangs: 'Preencha os 7 idiomas.',
      globalToggles: 'Chaves globais',
      streakEnabled: 'Sequência ativa',
      multinomination: 'Multinomeação',
      dailyHabitsMandatory: 'Hábitos diários obrigatórios',
      antiSpoiler: 'Anti-spoiler',
      antiSpoilerTitle: 'Modo Anti-Spoiler (Premiação)',
      antiSpoilerDesc: 'Desativa temporariamente a vista de perfis e reconhecimentos de terceiros durante a premiação anual, para não revelar os vencedores.',
      antiSpoilerActivo: 'Anti-spoiler ativo',
      antiSpoilerFrom: 'De',
      antiSpoilerTo: 'Até',
      antiSpoilerHint: 'Enquanto estiver ativo, os colaboradores não conseguem ver perfis de colegas nem o detalhe de reconhecimentos de terceiros.',
      antiSpoilerSinVentana: 'Sem datas, protege enquanto o interruptor estiver ligado.',
      antiSpoilerVentanaInvertida: '«De» é posterior a «Até»: assim a janela nunca protege. Corrija para poder guardar.',
      wrappedByOu: 'Wrapped por OU',
      reactionsEnabled: 'Reações (👏❤️😊🎉👍)',
      allowPromoteToBrillamos: 'Permitir enviar para Brillamos',
      allowPostEdit: 'Edição pós-envio',
      postEditTitle: 'Edição de Reconhecimentos Enviados',
      postEditDesc: 'Permite ao remetente editar a mensagem de um reconhecimento já enviado. Desativado por omissão.',
      postEditWindow: 'Janela de edição',
      postEditWindowOpt: { '24h': '24 horas', '48h': '48 horas', '7d': '7 dias', unlimited: 'Sem limite' },
      streakPerPersonCapEnabled: 'Limite por pessoa (sequência)',
      streakPerPersonCap: 'Máx. por pessoa (sequência)',
      weeklyMinimum: 'Mínimo por período',
      periodicity: 'Periodicidade',
      period: { weekly: 'Semanal', monthly: 'Mensal' },
      periodicityHint: 'O mínimo aplica-se ao período escolhido: com Mensal, a sequência soma ou quebra por mês civil, não por semana.',
      periodicityMonthlyWarning: 'Com Mensal a sequência conta MESES consecutivos e a aplicação já o reflete (widget, Perfil, Wrapped e limiares). Faltam DUAS decisões de Produto antes de ativar em produção: o RF-038 define os limiares de insígnia em semanas (1/4/8/12/20), pelo que a de 4 seria alcançada aos 4 meses; e o limite anti-abuso de 2 reconhecimentos por pessoa passa de semanal a mensal, o que pode tornar inalcançável um mínimo alto em equipas pequenas.',
      freezeFrom: 'Freeze desde',
      freezeTo: 'Freeze até',
      badges: 'Insígnias',
      noBadges: 'Não há insígnias configuradas.',
      badge: 'Insígnia',
      weeksRequired: '{{count}} semanas',
      weeksRequiredOne: '{{count}} semana',
      weeksRequiredMany: '{{count}} semanas',
      badgeName: 'Nome da insígnia',
      badgeIcon: 'Ícone',
      badgeColor: 'Cor',
      weeks: 'Semanas necessárias',
      notApplicable: 'Não se aplica',
      iconFormatInvalid: 'Formato de imagem inválido. Use PNG, JPG, WEBP ou SVG.',
      addBadge: '+ Adicionar insígnia',
      editBadge: 'Editar',
      deleteBadge: 'Eliminar',
      deleteBadgeConfirm: 'Eliminar o emblema «{{name}}»? Perdem-se o nome nos 7 idiomas, o ícone e o limiar. A eliminação aplica-se ao guardar.',
      badgeActive: 'Ativa',
      badgeInactive: 'Inativa',
      imageUploadHintNew: 'Guarde a insígnia primeiro para poder enviar o ícone.',
      previewTitle: 'Pré-visualização',
      saveBadgeChanges: 'Guardar alterações',
    },
    // FASE 7 (paridade demo, H-93/H-94/H-95) — Admin › Notificações (REQ-135).
    notifications: {
      title: 'Configuração de Notificações',
      desc: 'Configure quais avisos por e-mail são enviados e em que nível da organização. Os valores não definidos neste nível são herdados do seguinte.',
      precedenceTitle: 'Como a configuração é resolvida',
      precedence1: 'Precedência: Site > BU > OU > Global. Prevalece o valor definido no nível mais específico.',
      precedence2: 'Um botão «Herdado» não está desligado: assume o valor do nível inferior. Só se guarda o que definir aqui.',
      precedence3: 'Cada pessoa também pode desativar os próprios e-mails no seu perfil; essa preferência nunca reativa o que for desligado aqui.',
      scopeTitle: 'Nível de configuração',
      scopeUnit: 'Unidade',
      scopePick: 'Selecione uma unidade…',
      scopeRequired: 'Selecione uma unidade para ver e editar a sua configuração.',
      scopeOuContext: 'OU da unidade',
      scopeOuFirst: 'Selecione primeiro uma OU…',
      unsavedLock: 'Tem alterações por guardar; o nível fica fixo até guardar ou descartar.',
      discard: 'Descartar alterações',
      scope: { global: 'Global (todo o tenant)', ou: 'OU', bu: 'Business Unit', site: 'Site' },
      group: { email: 'E-mail', categories: 'Tipos de aviso', summary: 'Resumo periódico', blocked: 'E-mails bloqueados' },
      blocked: {
        desc: 'Endereços que não receberão nenhum e-mail do programa, seja qual for a sua configuração pessoal.',
        scopeWarning: 'O bloqueio abrange o tenant INTEIRO, não apenas este nível: um e-mail bloqueado aqui fica bloqueado em todas as OUs. E prevalece sobre o interruptor principal.',
        placeholder: 'correio@empresa.com',
        add: 'Bloquear',
        remove: 'Retirar o bloqueio de {{email}}',
        empty: 'Não há nenhum e-mail bloqueado.',
      },
      design: {
        title: 'Design dos e-mails',
        desc: 'É assim que ficam hoje: os Fundamentais usam um estilo quente e o Shine Together um estilo escuro com estrelas. O design de cada e-mail define-se na própria plantilla, não aqui.',
        fund: { name: 'Fundamentais', style: 'Estilo quente · Creme/Laranja' },
        shine: { name: '✨ Shine Together', style: 'Estilo escuro · Estrelas/Roxo' },
      },
      broadcast: {
        title: 'Avisos do sistema',
        desc: 'Para manutenções, interrupções ou qualquer aviso pontual. É enviado com a plantilla já desenhada: basta escrever a mensagem.',
        overridesHint: '🔴 Este aviso chega a TODA A GENTE, mesmo a quem desligou as notificações. Não é conteúdo do programa: é informação sobre a ferramenta.',
        kindLabel: 'Tipo de aviso',
        kind: { maintenance: 'Manutenção programada', suspension: 'Interrupção temporária', restored: 'Serviço reposto', general: 'Aviso geral' },
        subject: 'Assunto',
        subjectPlaceholder: 'Manutenção programada — sábado às 2h',
        message: 'Mensagem',
        messagePlaceholder: 'Mensagem para os utilizadores...',
        everyone: 'Toda a gente',
        singleOu: 'Uma OU específica',
        chooseOu: 'Escolha uma OU',
        send: 'Enviar aviso agora',
        error: 'Não foi possível enviar o aviso.',
        sentSummary: 'Enviado a {{sent}} de {{recipients}} pessoas.',
        skipped: '· {{count}} sem identidade resolúvel não o receberam.',
      },
      channel: { inapp: 'Sino', email: 'E-mail', teams: 'Teams' },
      tables: {
        shine: '✨ Notificações — Shine Together',
        admin: '🛡️ Notificações — Admin',
        colType: 'Tipo',
        colSubject: 'Assunto (ES)',
        colLanguages: 'Idiomas',
        editSubject: 'Editar o assunto de «{{row}}» nos 7 idiomas',
        subjectByLanguage: 'Assunto por idioma',
        close: 'Fechar',
        saveSubject: 'Guardar assunto',
        nineRows: 'Nove linhas e não treze: quatro das que a maqueta desenha não correspondem a nenhum aviso que o sistema envie hoje.',
        rows: {
          'campaign-new': { name: 'Nova campanha lançada', trigger: 'Um administrador ativa uma campanha' },
          'campaign-ending': { name: 'Campanha a terminar', trigger: 'Últimos dias para nomear' },
          'recognition-sent': { name: 'Reconhecimento enviado ao Shine Together', trigger: 'Confirmação de que contou para a campanha' },
          'ranking-position': { name: 'Posição no ranking', trigger: 'Sobe no leaderboard' },
          'campaign-approval': { name: 'Pedido de campanha por localidade', trigger: 'Um administrador de OU cria um pedido → Administrador Global' },
          'moderation-case-alert': { name: 'Denúncia de moderação', trigger: 'Há uma denúncia nova pendente para o administrador da OU' },
          'moderation-educational': { name: 'Mensagem denunciada, aviso ao emissor', trigger: 'Avisa quem enviou o reconhecimento de que foi denunciado' },
          'low-participation-alert': { name: 'Alerta de participação baixa', trigger: 'Uma campanha está abaixo do limiar de participação' },
          'pending-nomination-manager': { name: 'Nomeação pendente (líder)', trigger: 'Uma nomeação requer aprovação' },
        },
      },
      master: {
        label: 'Notificações por E-mail',
        desc: 'Interruptor principal: se estiver desligado, nenhum e-mail do programa é enviado neste âmbito. Não afeta o Teams nem o sino.',
      },
      cat: {
        recognitionReceivedEnabled: { label: 'Reconhecimentos recebidos', desc: 'Aviso à pessoa quando alguém a reconhece.' },
        streakAndBadgesEnabled: { label: 'Sequências e insígnias', desc: 'Lembretes de sequência e insígnias desbloqueadas.' },
        campaignsEnabled: { label: 'Campanhas', desc: 'Nova campanha, campanha a terminar, vencedores e aprovações.' },
        digestEnabled: { label: 'Resumo semanal', desc: 'Digest com a atividade acumulada da semana.' },
      },
      monthly: {
        label: 'Resumo mensal',
        desc: 'Desativado por padrão. Ative-o apenas se esta unidade também quiser um resumo mensal.',
      },
      masterOffHint: 'Os tipos individuais só funcionam com o interruptor principal ligado.',
      inherited: 'Herdado',
      inApp: { label: 'Notificações na aplicação (sino)', desc: 'O sino do portal. Não depende do interruptor de email: é um canal à parte.' },
      teams: { label: 'Activity Feed do Teams', desc: 'O aviso no feed de atividade do Teams, para quem tem conta corporativa.' },
      frequency: {
        label: 'Frequência de envio (email)',
        desc: 'De quanto em quanto tempo os avisos são agrupados num resumo. Não afeta os emails por evento.',
        opt: {
          immediate: 'Imediato (por evento)',
          daily: 'Resumo diário',
          weekly: 'Resumo semanal',
          biweekly: 'Resumo quinzenal (de 2 em 2 semanas)',
        },
        immediateHint: 'Com «Imediato» não é enviado qualquer resumo, mesmo que a categoria continue ligada: cada aviso sai por si.',
      },
      resetToInherited: 'Voltar a herdado',
      active: 'ativos',
      saved: 'Alterações guardadas!',
      loadError: 'Não foi possível carregar a configuração deste nível.',
      saveError: 'Não foi possível guardar a configuração. Tente novamente.',
    },
    views: {
      title: 'Visualizações do Utilizador',
      desc: 'Visualizações visíveis para o colaborador e microsites.',
      descLong: 'Que vistas cada OU oferece aos seus colaboradores. Compatível desktop + móvel.',
      scope: 'Nível de configuração',
      scopeGlobal: 'Global (todas as OUs)',
      unsavedLock: 'Guarde ou descarte as alterações antes de mudar de nível.',
      infoAria: 'Ajuda sobre {{label}}',
      micrositesTitle: 'URLs de Microsites por Fundamental',
      micrositesDesc: 'Ligação externa com mais informação de cada Fundamental. Deixe vazio se não houver microsite.',
      card: {
        medallero: { label: 'Medalheiro', desc: 'Enviados + recebidos' },
        perfilUsuario: { label: 'Perfil de utilizador', desc: 'Recebidos recente→antigo' },
        enviarReconocimiento: {
          label: 'Enviar reconhecimento', desc: 'Conforme a configuração do admin',
          tooltip: 'Mostra o botão e o formulário para reconhecer um colega. Combina-se com o interruptor geral de envios: se esse estiver desligado, esta vista não aparece mesmo que esteja ligada aqui.',
        },
        historicoPorAnio: {
          label: 'Histórico por ano', desc: 'Ano atual primeiro',
          tooltip: 'Permite ver o histórico de reconhecimentos agrupado por ano, com o ano atual primeiro. Também depende de a campanha ativa ter o histórico ativado.',
        },
        leaderboard: {
          label: 'Leaderboard', desc: 'Ranking',
          tooltip: 'Mostra o ranking de quem mais enviou ou recebeu reconhecimentos. É a única vista que vem desligada por predefinição.',
        },
        feedActividad: { label: 'Feed de atividade', desc: 'Cronologia recente' },
        resumenMensual: {
          label: 'Resumo mensal', desc: 'Retrospetiva tipo Spotify',
          tooltip: 'Ativa a retrospetiva tipo "Wrapped" com os números do período de cada colaborador. Só aparece se o Wrapped estiver ativado para a OU e a campanha já tiver terminado.',
        },
        busquedaCompaneros: {
          label: 'Pesquisa de colegas', desc: 'Ver medalheiros de outros',
          tooltip: 'Permite pesquisar e ver o medalheiro de reconhecimentos de outros colegas. Fica oculta automaticamente enquanto o Modo Anti-Spoiler estiver ativo, para não estragar surpresas antes de uma premiação.',
        },
        vistaFundamentales: {
          label: 'Vista de Fundamentais', desc: 'Informação de cada fundamental',
          tooltip: 'Mostra a constelação com a informação de cada Fundamental da cultura dentro do ecrã do Brillamos Juntos.',
        },
        banderaReportar: {
          label: 'Bandeira de denúncia', desc: 'Denunciar reconhecimentos inadequados',
          tooltip: 'Adiciona um botão para que os colaboradores possam denunciar um reconhecimento inadequado. Também depende de o botão de denúncia estar ativado em Moderação.',
        },
        recordatorioDiario: { label: 'Lembrete diário', desc: 'Incentivo diário para reconhecer' },
        verATuEquipo: {
          label: 'Ver a sua equipa', desc: 'Apenas líderes/gestores',
          tooltip: 'Permite a líderes e gestores ver os reconhecimentos das pessoas a seu cargo. Aplica-se apenas a quem tenha permissão de métricas de equipa e apareça como líder no organograma.',
        },
      },
      compose: {
        sending: 'Depende ainda do interruptor de pânico: com o envio desativado, esta vista não aparece mesmo que esteja ligada aqui.',
        campaign: 'Depende ainda do toggle de histórico da campanha ativa (RN-PR09).',
        wrapped: 'Depende ainda de a OU ter o Wrapped ativado e de a sua campanha ter encerrado.',
        antiSpoiler: 'Depende ainda do Modo Anti-Spoiler: enquanto a sua janela estiver ativa, esta vista fica oculta.',
        report: 'Depende ainda do toggle «Botão Denunciar» da secção Moderação.',
        manager: 'Depende ainda de ser líder no organigrama e de ter a permissão de métricas de equipa.',
      },
    },
    docs: {
      desc: 'Documentos corporativos e legais.',
      legalTab: 'Bases legais',
      privacyTab: 'Aviso de privacidade',
      corpTab: 'Corporativos',
      pillsTab: 'Pills de Utilizador',
      bibliotecaTab: 'Biblioteca',
      legalesTab: 'Docs Legais',
      gestionTitle: 'Gestão de Documentação',
      gestionDesc: 'Configure os acessos rápidos do utilizador, gira a biblioteca de ficheiros e os documentos legais obrigatórios.',
      pills: {
        nueva: 'Adicionar pill',
        sectionTitle: 'Acessos Rápidos (Pills)',
        sectionSubtitle: 'Cápsulas de acesso rápido visíveis na interface do utilizador. Defina o nome, o ícone, a cor e o conteúdo que abrem ao clicar.',
        editar: 'Editar pill',
        titulo: 'Título',
        tipo: 'Tipo',
        tipos: { documento: 'Documento', url: 'Link', video: 'Vídeo' },
        icono: 'Ícone',
        color: 'Cor',
        orden: 'Ordem',
        documento: 'Documento corporativo',
        elegirDocumento: 'Escolher documento…',
        sinDocumentos: 'Não há documentos corporativos disponíveis. Envie-os no separador Corporativos.',
        url: 'URL de destino',
        visibilidad: 'Visibilidade por OU',
        visibilidadHint: 'Sem OU selecionada = visível para todas as unidades.',
        activa: 'Pill ativa (exibida no rail)',
        activaSi: 'Ativa',
        activaNo: 'Inativa',
        estado: 'Estado',
        vistaPrevia: 'Pré-visualização',
        nombre: 'Nome',
        tipoContenido: 'Tipo de conteúdo',
        documentoColumna: 'Documento associado',
        documentoNoEncontrado: 'Documento não encontrado',
        documentoAlcanceIncompleto: 'Não cobre todas as OUs desta pill',
        sinTitulo: 'Sem título',
        todas: 'Todas',
        vacio: 'Ainda não há acessos rápidos configurados.',
        eliminar: 'Eliminar pill',
        eliminarConfirm: 'Eliminar este acesso rápido do rail?',
        errorCargar: 'Não foi possível carregar os acessos rápidos.',
        errorGuardar: 'Não foi possível guardar o acesso rápido.',
        errorEliminar: 'Não foi possível eliminar o acesso rápido.',
      },
      corp: {
        firstLogin: 'Primeiro login',
        versionEs: 'Versão ES',
        versionEn: 'Versão EN',
        subirVersion: 'Enviar',
        reemplazar: 'Substituir',
        verVersion: 'Ver versão',
        quitarVersion: 'Remover versão',
        triggerUpdate: 'Detonar atualiz.',
        ousActivas: 'OUs ativas',
        nombre: 'Nome do documento',
        tipo: 'Tipo',
        visibilidad: 'Visibilidade por OU',
        idiomas: 'Idiomas',
        idiomasHint: 'Sem seleção = todos os idiomas.',
        versionesPorIdioma: 'Versões por idioma',
        versionesPorIdiomaCount: 'Versões ({{count}}/{{total}})',
        archivo: 'Ficheiro PDF',
        elegirArchivo: 'Escolher PDF…',
        subir: 'Enviar documento',
        agregarDocumento: 'Adicionar documento',
        subirArchivo: 'Enviar ficheiro',
        libType: { todos: 'Todos', pdf: 'PDF', video: 'Vídeo', imagen: 'Imagem' },
        filterType: 'Tipo',
        nombreArchivo: 'Nome do ficheiro',
        idioma: 'Idioma',
        pillAsignado: 'Pill atribuída',
        subido: 'Enviado',
        documento: 'Documento',
        actualizado: 'Atualizado',
        mediaKind: 'Tipo de ficheiro',
        externalUrl: 'URL externa',
        externalUrlHint: 'Cole o link do vídeo ou da imagem (Teams, SharePoint, etc.).',
        requiereUrl: 'Insira uma URL externa válida.',
        abrir: 'Abrir',
        dropMain: 'Arraste ficheiros aqui ou clique para carregar',
        dropSub: 'PDF · Máx. 25 MB por ficheiro',
        subidoOk: 'Documento enviado.',
        errorSubir: 'Não foi possível enviar o documento.',
        lista: 'Documentos enviados',
        listaCount: '{{count}} documentos configurados',
        legalInfo: 'Estes documentos são mostrados no modal de aceitação obrigatório. Primeiro login os ativa no primeiro acesso. Acionar atualização volta a mostrá-los mesmo que o utilizador já os tenha aceitado. É necessária aceitação explícita para continuar.',
        searchPlaceholder: 'Pesquisar ficheiro…',
        filterLang: 'Filtrar por idioma',
        filterLangAll: 'Todos os idiomas',
        noResults: 'Nenhum documento corresponde ao filtro.',
        vacio: 'Ainda não há documentos corporativos.',
        fecha: 'Data',
        acciones: 'Ações',
        descargar: 'Descarregar',
        editar: 'Editar',
        eliminar: 'Eliminar',
        guardar: 'Guardar alterações',
        cancelar: 'Cancelar',
        eliminarConfirm: 'Eliminar este documento do repositório?',
        errorEliminar: 'Não foi possível eliminar o documento.',
        errorActualizar: 'Não foi possível atualizar o documento.',
        errorCargar: 'Não foi possível carregar a lista.',
        soloPdf: 'Somente PDF de até 25 MB é permitido.',
        requiereNombre: 'Insira um nome.',
        requiereOu: 'Selecione pelo menos uma OU.',
        requiereArchivo: 'Escolha um ficheiro PDF.',
        tipos: {
          PoliticaPrivacidad: 'Política de Privacidade',
          BasesLegales: 'Termos Legais',
          GuiaUsuario: 'Guia do Utilizador',
          Premios: 'Prémios',
          CookiesPolicy: 'Política de Cookies',
          LegalNotice: 'Aviso Legal',
        },
      },
      currentVersion: 'Versão vigente',
      noVersionYet: 'Ainda não foi publicada nenhuma versão',
      newVersionLabel: 'Nova versão a publicar',
      loadError: 'Não foi possível carregar o rascunho.',
      titleLabel: 'Título',
      sectionHeading: 'Cabeçalho',
      sectionBody: 'Corpo',
      addSection: 'Adicionar secção',
      removeSection: 'Remover secção',
      saveDraft: 'Guardar rascunho',
      publish: 'Publicar',
      publishConfirm: 'Está prestes a publicar uma nova versão. Todos os utilizadores precisarão aceitá-la novamente antes de poder reconhecer. Continuar?',
      missingLanguages: 'Faltam idiomas: {{languages}}',
      draftSaved: 'Rascunho guardado',
      published: 'Versão publicada',
      saveError: 'Não foi possível guardar o rascunho.',
      publishError: 'Não foi possível publicar a versão.',
    },
    recap: {
      title: 'Recap Anual',
      desc: 'Configure a experiência Recap por edição. Os fundos e os ícones são configuráveis por slide; os dados do utilizador (reconhecimentos, Fundamental mais recebido, fã nº 1, sequência) são injetados automaticamente pela plataforma.',
      deniedRole: 'A gestão do Recap é reservada ao Admin Geral e ao Admin Fundamentais.',
      fixValidation: 'Preencha os textos obrigatórios antes de guardar.',
      noEditions: 'Ainda não há edições do Recap.',
      createFirst: 'Criar a primeira edição',
      edition: 'Edição',
      editionName: 'Nome visível para o utilizador',
      newEdition: 'Nova edição',
      scope: 'Alcance OU',
      scopeGlobal: 'Global (todas)',
      active: 'Recap ativo',
      activeOn: 'Ativo',
      activeOff: 'Inativo',
      visibleFrom: 'Início de visibilidade',
      visibleTo: 'Fim de visibilidade',
      notification: 'Notificação',
      notifiedAt: 'Enviada {{date}}',
      neverNotified: 'Sem notificar',
      difusionLockHint: 'Este Recap já foi divulgado. Pode ALARGAR o âmbito e a janela de visibilidade, mas não reduzi-los: retirar uma OU ou encurtar as datas deixaria de fora pessoas que já foram avisadas. O resto da edição continua editável.',
      slidesTitle: 'Configuração de slides ({{count}} slides)',
      slidesHint: 'Os ícones de Fundamentais e os dados do utilizador são injetados automaticamente. Aqui configura apenas a camada visual e os textos.',
      i18nHint: 'Multi-idioma: o título de cada slide é capturado nos 7 idiomas pelo botão Editar.',
      colSlide: 'Slide',
      colPreview: 'Pré-visualização',
      colTitle: 'Título',
      colActive: 'Ativo',
      colActions: 'Ações',
      edit: 'Editar',
      titleMissing: 'Sem título',
      needAllLangs: 'Faltam idiomas por preencher (são necessários os 7).',
      slides: {
        portada:    { name: 'Capa',                     hint: 'Ecrã de boas-vindas' },
        numeros:    { name: 'Seu ano em números',       hint: 'Recebidos + enviados' },
        define:     { name: 'O que te define',          hint: 'Fundamental mais recebido (dado automático)' },
        mensaje:    { name: 'A mensagem',               hint: 'Reconhecimento mais longo (dado automático)' },
        quienes:    { name: 'Quem te reconheceu',       hint: 'Totais e pessoas (dado automático)' },
        red:        { name: 'Sua rede',                 hint: 'Áreas distintas que te reconheceram (dado automático)' },
        constancia: { name: 'Sua constância',           hint: 'Sequência de semanas (dado automático)' },
        reto:       { name: 'Seu desafio do próximo ano', hint: 'Fundamental menos mostrado e chamada à ação' },
        ganador:    { name: 'Vencedor Anual',           hint: 'Se o utilizador foi vencedor: insígnia real da secção Vencedores' },
      },
      notifyTitle: 'Notificação do Recap',
      notifyDesc: 'Avise os colaboradores do alcance selecionado que o Recap {{year}} deles já está pronto.',
      preview: 'Pré-visualização',
      send: 'Enviar notificação',
      notifyNeedsActive: 'Ative a edição para poder notificá-la.',
      notifyError: 'Não foi possível enviar a notificação.',
      previewNote: 'É assim que a edição é percorrida: apenas os slides ativos, com seus fundos e títulos. Os números são do utilizador que a abrir.',
      genericTitle: 'Mensagem genérica (reserva)',
      genericDesc: 'É exibida quando o utilizador não tem reconhecimentos no período ou quando entra antes de o Recap estar visível.',
      genericTitleLabel: 'Título da mensagem genérica',
      genericDescLabel: 'Subtítulo / descrição',
      genericNote: 'Esta mensagem é a reserva: quem tiver dados verá seu Recap personalizado.',
      imageUrlPlaceholder: 'URL da imagem (PNG / JPG)',
      historyTitle: 'Histórico de Recap e vencedores anuais',
      historyDesc: 'Edições registradas e os vencedores anuais associados a cada uma.',
      colEdition: 'Edição',
      colYear: 'Ano',
      colScope: 'Alcance',
      colSlides: 'Slides',
      colWinners: 'Vencedores anuais',
      colStatus: 'Estado',
      winnersCount: '{{count}} vencedores',
      status: { activa: 'Ativa', completada: 'Concluída', borrador: 'Rascunho' },
      editorTitle: 'Editar slide {{index}}',
      editorDescData: 'Configure o título (7 idiomas), o fundo e o texto que acompanha o dado dinâmico. A pré-visualização é atualizada enquanto escreve.',
      editorDescIcon: 'Configure o título (7 idiomas), o fundo e o ícone do slide. A pré-visualização é atualizada enquanto escreve.',
      titleLangs: 'Título (7 idiomas)',
      titlePlaceholder: 'Título em {{lang}}',
      autoIcon: 'O ícone deste slide é automático: usa a insígnia real do vencedor configurada em Vencedores.',
      icon: 'Ícone',
      iconPlaceholder: 'Emoji ou URL de imagem',
      numberLabels: 'Texto abaixo dos números',
      numberLabelsHint: 'Os números são calculados pela plataforma; aqui define a palavra que vai abaixo.',
      numberLabelPlaceholder: 'Ex.: recebidos',
      background: 'Fundo',
      previewLabel: 'Pré-visualização',
      previewDataNote: 'Os números exibidos são do utilizador que abre seu Recap.',
      apply: 'Aplicar',
    },
  },
  // ── WP-16 REQ-140 — Modais legais ──
  legal: {
    privacy: 'Política de Privacidade',
    legal: 'Regulamento do Programa',
    reachedEnd: 'Chegou ao fim!',
    scrollHint: 'Role até o fim para aceitar',
    accept: 'Aceito',
    acceptError: 'Não foi possível registrar seu aceite.',
    loadError: 'Não foi possível carregar o documento.',
    pdfError: 'Não foi possível mostrar o documento PDF.',
    retry: 'Tentar novamente',
    openInNewTab: 'Abrir num novo separador',
  },
  // ── WP-16 REQ-139 — Registro standalone Frontline ──
  register: {
    backToLogin: '← Voltar ao início de sessão',
    entraTitle: 'Já tem e-mail institucional?',
    entraSub: 'Não precisa de se registar — entre diretamente com a sua conta Sigma.',
    title: 'Registo',
    subtitle: 'Crie seu acesso ao Programa de Reconhecimento.',
    fullName: 'Nome completo',
    email: 'E-mail',
    ou: 'Unidade organizacional',
    selectOu: 'Selecione sua OU',
    startDate: 'Data de admissão na Sigma',
    employeeId: 'Número de matrícula',
    bu: 'Unidade de negócio',
    site: 'Local de trabalho',
    department: 'Departamento',
    selectBu: 'Selecione sua Unidade de Negócio',
    selectSite: 'Selecione seu local de trabalho',
    selectDepartment: 'Selecione seu departamento',
    errName: 'Informe seu nome completo.',
    errEmail: 'Informe um e-mail válido.',
    errOu: 'Selecione sua OU.',
    errCatalogs: 'Preencha unidade de negócio, local e departamento.',
    errStartDate: 'Informe sua data de admissão.',
    errEmployeeId: 'Informe seu número de matrícula.',
    catalogsError: 'Não foi possível carregar os catálogos.',
    submit: 'Registar-me',
    submitError: 'Não foi possível concluir o registo.',
    checkEmailTitle: 'Verifique seu e-mail',
    checkEmailSub: 'Enviamos um link de verificação para {{email}}.',
    verifyFailed: 'Não foi possível verificar seu e-mail. O link pode ter expirado.',
    verified: 'E-mail verificado',
    allSet: 'Tudo pronto!',
    allSetSub: 'Sua conta foi configurada. Já pode reconhecer seus colegas.',
    password: 'Palavra-passe (mín. 8 caracteres)',
    confirmPassword: 'Confirmar palavra-passe',
    errPassword: 'A palavra-passe deve ter pelo menos 8 caracteres.',
    errPasswordMatch: 'As palavras-passe não coincidem.',
    errLegal: 'Deve aceitar o Regulamento.',
    errLegalVersion: 'Não foi possível carregar o documento legal. Tente novamente.',
    errPrivacy: 'Deve aceitar a Política de Privacidade.',
    errLocalId: 'Introduza o seu Local ID (até 8 dígitos).',
    errDepartment: 'Selecione seu departamento.',
    acceptPrivacy: 'Li e aceito a',
    acceptLegalBases: 'Li e aceito o',
    privacyLink: 'Política de Privacidade',
    legalLink: 'Regulamento',
    localId: 'Local ID',
    policyPlaceholder: 'Leia o documento completo. Ao chegar ao fim, poderá aceitá-lo.',
    createdTitle: 'Conta criada',
    createdSub: 'Já pode entrar com seu e-mail e palavra-passe. Ao entrar, poderá escolher seu avatar.',
    checkEmailHint: 'Abra a ligação para confirmar o seu e-mail e poder iniciar sessão. Caduca dentro de 72 horas.',
    resend: 'Reenviar o e-mail',
    resendDone: 'Se a sua conta estiver pendente de verificação, enviámos-lhe outra ligação. Se já a verificou, inicie sessão com o seu e-mail e palavra-passe.',
  },
  // ── Login (RF-002) ──
  login: {
    title: 'Entrar',
    subtitle: 'Programa de Reconhecimento',
    entraRouteTitle: 'Entre com seu e-mail institucional',
    entraRouteSub: 'Use sua conta Sigma (Entra ID).',
    entra: 'Entrar com e-mail Sigma',
    frontlineRouteTitle: 'Não tem e-mail institucional?',
    frontlineRouteSub: 'Entre com seu e-mail e palavra-passe.',
    email: 'E-mail',
    password: 'Palavra-passe',
    submit: 'Entrar',
    submitting: 'A entrar…',
    or: 'ou',
    toRegister: 'Não tem conta? Registe-se',
    noAccountLede: 'Não tem conta institucional?',
    noAccountSub: 'Utilize um e-mail pessoal',
    alreadyRegisteredLede: 'Já se registou?',
    hasInstitutionalEmailLede: 'Tem um e-mail institucional?',
    register: 'Registe-se',
    back: 'Voltar',
    forgot: 'Esqueceu sua palavra-passe?',
    forgotIntro: 'Escreva o seu e-mail e enviamos-lhe uma ligação para criar uma palavra-passe nova.',
    forgotSubmit: 'Enviar-me a ligação',
    forgotSent: 'Se esse e-mail estiver registado, enviámos-lhe uma ligação. Caduca dentro de 60 minutos.',
    resendVerification: 'Não recebeu o e-mail de verificação?',
    resendIntro: 'Escreva o seu e-mail e enviamos-lhe outra ligação de verificação.',
    resendSubmit: 'Reenviar o e-mail',
    resendSent: 'Se a sua conta estiver pendente de verificação, enviámos-lhe outra ligação. Se já a verificou, inicie sessão com o seu e-mail e palavra-passe.',
    errRequired: 'Informe seu e-mail e palavra-passe.',
    errCredentials: 'E-mail ou palavra-passe incorretos.',
  },
  // ── Landing comum (regra #3) ──
  landing: {
    question: 'Quais Fundamentais vamos reconhecer hoje?',
    subtitle: 'Escolha um espaço para viver os seus Fundamentais',
    cardPulso: 'Post Meeting Pulse',
    cardShine: 'Shine Together',
    pulsoHover: 'Como foi sua equipa na última reunião? Conte a eles o que notou 💬',
    shineHover: 'Quer ver quem está a brilhar e indicar um colega?',
  },
  // Restablecimiento de contrasena Frontline (/app/restablecer)
  reset: {
    title: 'Crie a sua palavra-passe nova',
    subtitle: 'Escolha uma palavra-passe para voltar a entrar.',
    password: 'Palavra-passe nova (mín. 8 caracteres)',
    confirmPassword: 'Confirmar palavra-passe',
    submit: 'Alterar a minha palavra-passe',
    errPassword: 'A palavra-passe tem de ter pelo menos 8 caracteres.',
    errPasswordMatch: 'As palavras-passe não coincidem.',
    errInvalidLink: 'A ligação não é válida ou já caducou. Peça uma nova no ecrã de início de sessão.',
    doneTitle: 'Palavra-passe atualizada',
    doneSub: 'Já pode iniciar sessão com o seu e-mail e a palavra-passe nova.',
    noToken: 'Ligação inválida',
    noTokenSub: 'A ligação não é válida ou está incompleta. Verifique o e-mail que recebeu.',
  },
  auth: {
    retryIn: 'Pode tentar novamente dentro de {{seconds}} s',
    contactHR: 'Se tiver problemas para se registar, entre em contacto com sua equipa de Capital Humano.',
    errorTitle: 'Não foi possível continuar',
  },
  // ── WP-16 REQ-141 — Avatar ──
  avatar: {
    title: 'Escolha seu avatar',
    subtitle: 'Escolha a imagem que o representa.',
    loading: 'A carregar avatares…',
    empty: 'Ainda não há avatares disponíveis.',
    loadError: 'Não foi possível carregar os avatares.',
    saveError: 'Não foi possível guardar seu avatar.',
    saved: 'Avatar guardado',
    confirm: 'Confirmar',
    required: 'Escolha o seu avatar para continuar.',
    unavailable: 'Esse avatar deixou de estar disponível. Escolha outro.',
    change: 'Alterar avatar',
    continueWithout: 'Continuar sem avatar',
  },
  // ── WP-08 — Relatórios de Reconhecimento ──
  reports: {
    title: 'Relatórios',
    subtitle: 'Analítica do Programa de Reconhecimento. Nunca mostra pontos.',
    emptyScope: 'Não tem nenhuma unidade organizacional atribuída dentro do seu âmbito.',
    tabs: {
      daily: 'Reco Diário',
      shine: 'Brillamos Juntos',
      history: 'Históricos',
      heatmap: 'Mapa de calor',
      network: 'Rede ONA',
      generational: 'Demográfico',
      leaders: 'Líderes',
      moderation: 'Moderação',
      campaigns: 'Campanhas — geral',
    },
    common: {
      loading: 'A carregar relatórios…',
      error: 'Não foi possível carregar o relatório.',
      empty: 'Não há dados para os filtros selecionados.',
      retry: 'Tentar novamente',
      suppressedNote: 'Alguns agregados foram ocultados pelo limite de anonimato (menos de 5).',
      suppressedNoteHelp: 'Quando um grupo tem menos de 5 pessoas, as suas métricas desagregadas não são publicadas: com tão poucas, o dado permitiria identificar alguém por inferência. Não é um erro nem falta de informação.',
      colScope: 'Âmbito (unidades)',
      colScopeHelp: 'Unidades organizacionais a que a campanha se dirigiu.',
      colAudienceHelp: 'Número de colaboradores a quem a campanha se dirigiu. É o denominador da taxa de participação.',
      scopeAll: 'Toda a organização',
      scopeMore: '+{{n}} mais',
      masked: 'Oculto por anonimato',
      showingRange: 'A mostrar {{desde}}–{{hasta}} de {{total}}',
      pageSize: 'Linhas por página',
      perPage: '{{n}} por pág.',
      exportExcel: 'Exportar para Excel',
      yes: 'Sim',
      no: 'Não',
    },
    context: {
      unifiedTitle: 'Métricas unificadas',
      unifiedText: '— Reco Diário e Brillamos Juntos usam a mesma lógica de contagem. Os dados são consistentes entre módulos.',
      auditTitle: 'Auditoria ativa.',
      auditText: 'Cada descarregamento fica registado com o seu utilizador, o separador e a data.',
      showing: 'A mostrar:',
      wholeOrg: 'toda a organização',
    },
    filters: {
      allFundamentals: 'Todos os Fundamentais',
      allOus: 'Todas as OUs',
      dateFrom: 'De',
      dateTo: 'Até',
      reset: 'Limpar',
      ou: 'Unidade',
      fundamental: 'Fundamental',
      dateRange: 'Datas',
      remove: 'Remover filtro {{filter}}',
      person: 'Pessoa',
      personPlaceholder: 'Procurar pessoa…',
      personClear: 'Remover a pessoa selecionada',
      personNoResults: 'Sem correspondências no diretório',
      personSearching: 'A procurar…',
      personError: 'Não foi possível consultar o diretório',
    },
    notApplicable: {
      title_one: 'O filtro {{filtros}} não se aplica nesta secção.',
      // `title_few` — alias inerte de `title_other`, mantido só pela paridade de chaves com `ro`.
      title_few: 'Os filtros {{filtros}} não se aplicam nesta secção.',
      title_other: 'Os filtros {{filtros}} não se aplicam nesta secção.',
      and: 'e',
      reason: {
        censo: 'O censo do quadro de pessoal é uma fotografia do diretório no momento da consulta, não uma medição do período, pelo que não pode ser delimitado por Fundamental nem por pessoa.',
        embudo: 'O funil reparte toda a população entre Habituais, Ocasionais e Inativos; limitado a uma única pessoa deixaria de ser uma repartição.',
        historico: 'Estes números são de "alguma vez", não do período escolhido: contam quem alguma vez reconheceu alguém, em todo o seu histórico na plataforma.',
        audienciaCampana: 'Este indicador calcula-se sobre a audiência convocada pela campanha, que é a mesma independentemente do Fundamental ou da pessoa escolhida.',
        porBanda: 'A distribuição agrupa as pessoas por banda geracional; com uma única pessoa selecionada restaria uma única banda e deixaria de ser uma distribuição.',
        porOu: 'Esta vista agrupa por unidade organizativa, não por pessoa.',
        redOu: 'Os nós da rede são unidades organizativas, não pessoas.',
        promedioPulso: 'Esta tabela vem das pontuações médias de Pulso (1-4) por geração e Fundamental, não da contagem de reconhecimentos nem do censo do quadro de pessoal: nenhum dos dois filtros a delimita.',
        resumenCampana: 'Este indicador provém do resumo de toda a campanha: o backend não permite restringi-lo a uma única pessoa (mas permite restringi-lo por Fundamental).',
        casosReportados: 'O relatório lista CASOS reportados, e o motivo do reporte é escrito por quem reporta: não está ligado a um Fundamental do reconhecimento. A UO, o intervalo de datas e a pessoa restringem esta tabela.',
      },
    },
    daily: {
      title: 'Reconhecimento Diário',
      subtitle: 'Apenas reconhecimentos do dia a dia, sem campanhas: período escolhido vs. anterior, funil de participação e tops.',
      // T-05 — el tab respeta el rango del filtro, así que la comparativa ya no es «semana»
      // fija: es el periodo elegido contra el anterior equivalente. Sin rango, sigue siendo
      // la semana en curso, que es el valor por omisión que pide la Especificación.
      thisPeriod: 'Período selecionado',
      prevPeriod: 'Período anterior',
      vsPrev: '{{variacion}} vs. período anterior · {{previo}}',
      fundamentalDistribution: 'Distribuição por Fundamental',
      totalSentTitle: 'Total de reconhecimentos enviados',
      totalSentHint: 'Soma de todos os reconhecimentos enviados no período',
      retiredFundamental: 'Fundamental retirado',
      unresolvedFundamental: 'Fundamental (sem catálogo)',
      retiredFundamentalHint: 'Fundamental retirado do catálogo: mantém-se no histórico porque houve reconhecimentos com ele, mas já não pode ser escolhido.',
      adoptionStaff: 'Utilizadores Staff',
      adoptionFrontline: 'Utilizadores Frontline',
      adoptionTotal: 'Utilizadores totais',
      noActivity: 'Sem atividade',
      adoptionHint: '{{reconocedores}} de {{plantilla}} já reconheceram alguém',
      adoptionTotalHint: '{{pct}} do total de efetivos ({{plantilla}})',
      noActivityHint: 'Nunca enviaram um reconhecimento',
      variation: 'Variação',
      sparkAria: 'Tendência diária de {{label}}: {{dias}} dias, de {{primero}} a {{ultimo}}',
      uniquePeople: 'Pessoas únicas',
      pares: 'Pares',
      lideres: 'Líderes',
      funnel: 'Funil de participação',
      funnelMonthSelector: 'Mês do funil de participação',
      funnelRange: 'Período: {{from}} – {{to}}',
      funnelPeople: '{{count}} pessoas',
      topPeople: 'Top pessoas reconhecidas',
      topRecognizers: 'Top reconhecedores',
      topFundamentals: 'Top fundamentais',
      // E6 — botón de export multi-hoja (7 hojas) del tab completo.
      exportMultiSheet: 'Exportar Diário (6 folhas)',
      colStage: 'Etapa',
      // C2 — las ocho columnas de los Top-10 de la maqueta.
      colName: "Nome",
      colDepto: "Departamento",
      colOu: "OU",
      colFundamental: "Fundamento",
      colRecos: 'Reconhecimentos',
      colEnviados: "Enviados",
      colCrossOu: "Entre OU",
      colType: "Tipo",
      crossOu: {
        si: "Sim",
        no: "Não",
        desconocido: "—",
      },
      // Las 4 columnas que el Excel comparte con «Brillamos Juntos» (`excelPlantillaTeal.ts`, el
      // mismo constructor arma las hojas de ranking de los dos reportes) y que la pantalla del
      // Diario no pinta.
      colEmail: 'Correio eletrónico',
      colEmployeeId: 'Número de funcionário',
      colRecognitions: 'Reconhecimentos',
      colDominantType: 'Tipo dominante',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Reconocimiento Diario (`dailyExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `01 - Reconocimiento Diario.xlsx`
      // (auditoría 2026-09-05). El libro entero sale en el idioma de quien descarga.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Resumo Executivo',
        sheetDefinitions: 'Definições',
        sheetFunnel: 'Funil de Adoção',
        sheetTopRecognized: 'Top Reconhecidos',
        sheetTopRecognizers: 'Top Reconhecedores',
        sheetAllRecognitions: 'Todos os reconhecimentos',
        summaryTitle: 'Reconhecimento Diário — Fundamentais do dia a dia',
        summarySubtitle: 'Indicadores do período selecionado: quem reconhece, a quem e com que frequência.',
        definitionsTitle: 'O que significa cada dado?',
        definitionsSubtitle: 'Explicação em linguagem simples, para qualquer pessoa que descarregue este ficheiro, sem precisar de perceber de dados.',
        funnelTitle: 'Funil de Adoção',
        funnelSubtitle: 'Segmentação calculada pela frequência de reconhecimentos enviados no mês do funil ({{rango}}).',
        funnelEmpty: 'Sem dados: não há reconhecimentos no mês do funil.',
        topRecognizedTitle: 'Mais reconhecidos',
        topRecognizersTitle: 'Top reconhecedores',
        rankingSubtitle: 'Classificação calculada pelos reconhecimentos deste período.',
        topRecognizersEmpty: 'Sem dados: ninguém reconheceu durante o período.',
        allRecognitionsTitle: 'Todos os reconhecimentos',
        allRecognitionsSubtitle: 'Detalhe em bruto do dia a dia no período, sem os envios de campanha: uma linha por candidato reconhecido. Os nomes das colunas mantêm a forma original para que as tabelas dinâmicas da comissão continuem a funcionar.',
        allRecognitionsNoRange: 'Sem dados: não foi possível determinar o intervalo exato do período, porque o agregado está suprimido pelo limiar de anonimato e o filtro não traz datas explícitas.',
        metaPeriod: 'Período',
        metaFilters: 'Filtros aplicados',
        metaFunnelMonth: 'Mês do funil',
        metaGenerated: 'Gerado',
        colKpi: 'KPI',
        colValue: 'Valor',
        colDetail: 'Detalhe',
        colDatum: 'Dado',
        colWhatIs: 'O que é',
        colHowCalculated: 'Como se calcula',
        colPercentOfTotal: '% do total',
        colSegment: 'Segmento',
        colPeople: 'Pessoas',
        colAdministrative: 'Administrativos',
        colOperational: 'Operacionais',
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Área',
        colSite: 'Site',
        headcountTitle: 'Quadro de pessoal',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Pessoas',
        kpiPeers: 'Pares (reconhecimentos únicos entre pares)',
        kpiLeaders: 'Líderes (reconhecimentos únicos com participação de um líder)',
        datumTeamRecognitions: 'Reconhecimentos feitos a equipas',
        datumAudienceStaff: 'Audiência Staff (administrativos)',
        datumAudienceFrontline: 'Audiência Frontline (operacionais)',
        datumComparison: 'Período anterior e variação',
        datumRankings: 'Top Reconhecidos / Top Reconhecedores',
        datumLeader: 'Líder',
        datumTruncated: 'Todos os reconhecimentos — truncado',
        whatRecognitionsMade: 'Quantos reconhecimentos foram enviados no total durante o período, com os filtros aplicados.',
        calcRecognitionsMade: 'Somam-se os reconhecimentos do dia a dia com data dentro do período escolhido. Os que pertencem a uma campanha são contados no relatório Brilhamos Juntos.',
        whatUniqueRecognized: 'Quantas pessoas diferentes receberam pelo menos um reconhecimento. Quem recebeu cinco conta uma só vez.',
        calcUniqueRecognized: 'Contam-se as pessoas diferentes que aparecem como recetoras no período.',
        whatTeamRecognitions: 'Um reconhecimento é de grupo quando tem mais do que um destinatário.',
        calcTeamRecognitions: 'A coluna «Recognition type» da folha «Todos os reconhecimentos» marca cada linha como Individual ou Grupal.',
        whatPeers: 'Reconhecimentos em que nem quem reconhece nem quem recebe tem pessoas a seu cargo: colaborador a colaborador, líder a líder, gestor a gestor.',
        calcPeers: 'Filtram-se os reconhecimentos entre pares dentro do período.',
        whatLeaders: 'Reconhecimentos em que participa pelo menos uma pessoa com equipa a seu cargo.',
        calcLeaders: 'Filtram-se os reconhecimentos em que quem envia ou quem recebe tem papel de líder, supervisor ou gestor.',
        whatStaffAdoption: 'De todas as pessoas de escritório (Staff), que percentagem já reconheceu alguém no período.',
        calcStaffAdoption: 'Pessoas Staff com pelo menos um reconhecimento enviado no período, a dividir pelo total de pessoas Staff do âmbito.',
        whatFrontlineAdoption: 'De todas as pessoas de operação ou fábrica (Frontline), que percentagem já reconheceu alguém no período.',
        calcFrontlineAdoption: 'Pessoas Frontline com pelo menos um reconhecimento enviado no período, a dividir pelo total de pessoas Frontline do âmbito.',
        whatTotalUsers: 'Quantas pessoas do âmbito enviaram pelo menos um reconhecimento alguma vez, desde que têm conta.',
        calcTotalUsers: 'Pessoas com pelo menos um reconhecimento enviado em todo o seu histórico. Não depende do período selecionado: vem do censo diário.',
        whatNoActivity: 'Pessoas que nunca enviaram um único reconhecimento desde que têm conta.',
        calcNoActivity: 'Quadro de pessoal total do âmbito menos as pessoas com pelo menos um reconhecimento enviado em todo o seu histórico.',
        whatAudienceStaff: 'Pessoas com conta corporativa do Entra ID.',
        whatAudienceFrontline: 'Pessoas que se registam na plataforma com o seu próprio correio eletrónico.',
        whatPrevPeriod: 'Reconhecimentos enviados nos mesmos dias imediatamente antes do período selecionado.',
        whatVariation: 'Quanto cresceu ou caiu o volume de reconhecimentos face ao período anterior equivalente.',
        calcVariation: 'O período anterior são os mesmos dias imediatamente antes do selecionado. A variação é a diferença entre ambos, a dividir pelo total do período anterior.',
        whatFunnel: 'Segmenta o âmbito por frequência dentro do mês do funil, uma janela própria e independente do período acima: Habituais (quatro ou mais por mês), Ocasionais (de um a três) e Inativos (nenhum). Cada etapa é desdobrada em administrativos e operacionais.',
        calcFunnel: 'A percentagem e a coluna Pessoas calculam-se sobre o quadro de pessoal do âmbito. Administrativos e operacionais contam essas mesmas pessoas por tipo de função e ficam em branco se essa classificação não estiver disponível.',
        whatRankings: 'As pessoas mais reconhecidas e quem mais reconhece no período, até 200 em cada lista.',
        calcRankings: 'Ordena-se pelo número de reconhecimentos recebidos ou enviados. Quem não atinge o limiar de anonimato sai mascarado.',
        whatAllRecognitions: 'Detalhe em bruto do período, uma linha por candidato: os blocos Nominee, OnBehalfOf e Candidate completos, a data, a matriz de Hábitos ativos e os indicadores de auditoria. Não mascara pessoas: é a fonte de trabalho da comissão, e o limiar de anonimato aplica-se aos relatórios agregados. Inclui os reconhecimentos de campanhas Brillamos Juntos em vigor, porque o Diário conta todos.',
        calcAllRecognitions: 'Lista completa dos reconhecimentos do período, até um máximo de 5000 linhas. As colunas de Hábitos só incluem os ativos no catálogo no momento da exportação. A coluna Reco_ID fica vazia porque o sistema ainda não gera um identificador único por linha.',
        whatTruncated: 'Esta descarga foi cortada no limite de 5000 linhas: o período tem mais reconhecimentos do que os que o ficheiro traz.',
        calcTruncated: 'O limite foi atingido antes de percorrer todas as páginas, por isso o ficheiro está incompleto. Restrinja o período e volte a exportar.',
        noteLeader: 'Um papel é considerado líder quando tem pessoas a seu cargo.',
        masked: 'Oculto por anonimato',
      },
    },
    shine: {
      title: 'Brilhamos Juntos',
      subtitle: 'Ranking de nomeações da campanha e KPIs ao vivo.',
      recognitionsMade: 'Reconhecimentos realizados',
      uniqueRecognized: 'Pessoas únicas reconhecidas',
      uniqueRecognizers: 'Pessoas únicas que reconhecem',
      participationRate: 'Taxa de participação',
      totalHeadcount: 'Efetivo total',
      // E6 — reemplaza al export de una sola hoja: ahora arma las 7 hojas del Excel de Brillamos.
      exportMultiSheet: 'Exportar Brillamos (7 folhas)',
      exporting: 'A exportar…',
      exportError: 'Não foi possível concluir a descarga. Tente de novo.',
      winnersFormat: 'Formato da exportação de vencedores',
      formatRaw: 'Bruto',
      formatCascaded: 'Em cascata',
      exportWinners: 'Exportar vencedores',
      colPos: 'Posição',
      kpiTotal: 'Total',
      kpiParticipants: 'Participantes',
      kpiParticipation: 'Participação',
      kpiAvgPerPerson: 'Média por pessoa',
      // T-10 — el tab es POR CAMPAÑA (confirmado con Adriana, 18-ago-2026): sin una elegida
      // los indicadores no pueden acotarse y se pide elegir, en vez de pintar los del scope.
      campaignSelector: 'Campanha',
      modalidadSelector: 'Filtro Brillamos',
      daysLeft: 'Dias restantes',
      activeOus: 'OUs ativas',
      modalidadTodos: 'Todos os nomeados',
      modalidadPersonaUnica: 'Apenas destinatário único',
      modalidadCrossOu: 'Cross-OU',
      pickCampaign: 'Escolha uma campanha para ver os seus indicadores e a classificação.',
      habitsRanking: 'Classificação de Daily Habits',
      colHabit: 'Daily Habit',
      colRecognitions: 'Reconhecimentos',
      colName: 'Nome',
      colBu: 'BU',
      colDept: 'Depto.',
      colOrigin: 'Origem',
      filterHabitsByFundamental: 'Filtrar hábitos por Fundamental',
      allFundamentals: 'Todos os Fundamentais',
      colCount: 'Reconhecimentos',
      colOu: 'OU',
      colCountry: 'País',
      colBadge: 'Insígnia',
      colCrossed: 'Origem cruzada',
      // Tarea 16 — las 6 columnas nuevas de "Top Reconocidos"/"Top Reconocedores" (11 columnas
      // exactas de la plantilla real del cliente). `colCrossOu` reusa la misma
      // traducción que ya usa `reports.daily` para el mismo dato.
      colEmail: 'E-mail',
      colEmployeeId: 'Nº Matrícula',
      colCrossOu: 'Entre OU',
      colDominantType: 'Tipo dominante',
      // Fix round 1 (Tarea 14) — reubicadas desde un bloque `shine` de nivel superior huérfano
      // (nunca se leía: el tab completo usa `reports.shine.*`), que quedaba fuera de `reports` y
      // duplicaba estas mismas 10 claves con el contenido correcto. Sin esto, `tarjetasDeAdopcion`
      // y el banner de filtros aplicados pintaban la clave cruda en vez del texto traducido.
      adoptionStaff: 'Utilizadores Staff',
      adoptionFrontline: 'Utilizadores Frontline',
      adoptionTotal: 'Utilizadores totais',
      noActivity: 'Sem atividade',
      adoptionHint: '{{reconocedores}} de {{plantilla}} nomearam',
      adoptionTotalHint: '{{pct}} da população total ({{plantilla}})',
      noActivityHint: 'Nunca enviaram uma nomeação',
      appliedFilters: 'Filtros aplicados:',
      appliedFiltersValue: 'Herdados do painel superior · Campanhas ativas',
      clearAll: 'Limpar tudo',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Brillamos Juntos (`brillamosExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `02 - Campana brillamos juntos.xlsx`
      // (auditoría 2026-09-05): nombres de hoja, banners, metadatos, encabezados de tabla y el
      // glosario completo de «Definiciones». El libro entero sale en el idioma de quien descarga.
      //
      // Las etiquetas de dato que la pantalla ya usa (`recognitionsMade`, `uniqueRecognized`,
      // `adoptionStaff`, `colName`, `colEmail`…) NO se repiten aquí: se reusan de arriba para que
      // la celda del Excel y la columna de la tabla digan lo mismo.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Resumo Executivo',
        sheetDefinitions: 'Definições',
        sheetDistribution: 'Distribuição Fundamental',
        sheetFunnel: 'Funil de Adoção',
        sheetTopRecognized: 'Mais Reconhecidos',
        sheetTopRecognizers: 'Quem Mais Reconhece',
        sheetAllRecognitions: 'Todos os reconhecimentos',
        summaryTitle: 'Campanha Brilhamos Juntos',
        definitionsTitle: 'O que significa cada dado?',
        definitionsSubtitle: 'Explicação em linguagem simples, para qualquer pessoa que transfira este ficheiro, sem necessidade de saber de dados.',
        distributionTitle: 'Distribuição por Fundamental',
        distributionSubtitle: 'Participação calculada a partir dos reconhecimentos desta campanha.',
        distributionChart: 'Reconhecimentos por Fundamental',
        distributionNote: 'Um reconhecimento pode incluir mais do que um Fundamental ou mais do que um Hábito ao mesmo tempo, e cada um é contado em separado: as somas desta tabela podem não coincidir com o total da campanha nem com a contagem do respetivo Fundamental.',
        distributionEmpty: 'Sem dados: a campanha não tem reconhecimentos com Fundamental registado no período.',
        funnelTitle: 'Funil de Adoção',
        funnelSubtitle: 'Segmentação calculada pela frequência de reconhecimentos enviados no período da campanha.',
        funnelEmpty: 'Sem dados: a campanha não tem reconhecimentos no período.',
        topRecognizedTitle: 'Mais reconhecidos',
        topRecognizersTitle: 'Quem mais reconhece',
        rankingSubtitle: 'Classificação calculada a partir dos reconhecimentos desta campanha.',
        topRecognizersEmpty: 'Sem dados: ninguém reconheceu dentro desta campanha.',
        allRecognitionsTitle: 'Todos os reconhecimentos',
        allRecognitionsSubtitle: 'Detalhe em bruto da campanha: uma linha por candidato reconhecido. Os nomes das colunas mantêm-se na forma original para que as tabelas dinâmicas da comissão continuem a funcionar.',
        metaPeriod: 'Período',
        metaFilters: 'Filtros aplicados',
        metaGenerated: 'Gerado',
        colKpi: 'KPI',
        colValue: 'Valor',
        colDetail: 'Detalhe',
        colDatum: 'Dado',
        colWhatIs: 'O que é',
        colHowCalculated: 'Como se calcula',
        colFundamentals: 'Fundamentais',
        colPercentOfTotal: '% do total',
        colSegment: 'Segmento',
        colPeople: 'Pessoas',
        colAdministrative: 'Administrativos',
        colOperational: 'Operacionais',
        // El Fundamental de una fila del ranking. Clave propia y no la de `reports.daily`:
        // `brillamosExcel.ts` resuelve todo su texto bajo `reports.shine`.
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Área',
        colSite: 'Local',
        headcountTitle: 'Efetivo',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Pessoas',
        kpiPeers: 'Pares (reconhecimentos únicos entre pares)',
        kpiLeaders: 'Líderes (reconhecimentos únicos com participação de um líder)',
        kpiTotalSent: 'Total de reconhecimentos enviados',
        kpiIndividual: 'Total de reconhecimentos a uma só pessoa',
        kpiGroup: 'Total de reconhecimentos feitos a grupos',
        datumTeamRecognitions: 'Reconhecimentos feitos a equipas',
        datumAudienceStaff: 'Público Staff (administrativos)',
        datumAudienceFrontline: 'Público Frontline (operacionais)',
        datumLeader: 'Líder',
        datumTruncated: 'Todos os reconhecimentos — truncado',
        whatRecognitionsMade: 'Quantos reconhecimentos foram enviados no total dentro da campanha, com os filtros aplicados.',
        calcRecognitionsMade: 'Somam-se todos os reconhecimentos com data dentro do período da campanha.',
        whatUniqueRecognized: 'Quantas pessoas diferentes receberam pelo menos um reconhecimento. Quem recebeu cinco conta uma só vez.',
        calcUniqueRecognized: 'Contam-se as pessoas diferentes que surgem como recetoras no período.',
        whatTeamRecognitions: 'Um reconhecimento é de grupo quando tem mais do que um destinatário.',
        calcTeamRecognitions: 'Contam-se os reconhecimentos com duas ou mais pessoas como destinatário.',
        whatIndividual: 'Reconhecimentos da campanha dirigidos a uma só pessoa.',
        calcIndividual: 'Contam-se os reconhecimentos com exatamente um destinatário.',
        whatPeers: 'Reconhecimentos em que nem quem reconhece nem quem recebe tem pessoas a seu cargo: colaborador a colaborador, líder a líder, gestor a gestor.',
        calcPeers: 'Filtram-se os reconhecimentos entre pares dentro desta campanha.',
        whatLeaders: 'Reconhecimentos em que participa pelo menos uma pessoa com pessoas a seu cargo.',
        calcLeaders: 'Filtram-se os reconhecimentos em que quem envia ou quem recebe tem função de líder, supervisor ou gestor.',
        whatStaffAdoption: 'De todas as pessoas de escritório (Staff), que percentagem já reconheceu alguém nesta campanha.',
        calcStaffAdoption: 'Pessoas Staff com pelo menos um reconhecimento enviado na campanha, a dividir pelo total de pessoas Staff do respetivo público.',
        whatFrontlineAdoption: 'De todas as pessoas de operação ou fábrica (Frontline), que percentagem já reconheceu alguém nesta campanha.',
        calcFrontlineAdoption: 'Pessoas Frontline com pelo menos um reconhecimento enviado na campanha, a dividir pelo total de pessoas Frontline do respetivo público.',
        whatTotalUsers: 'Quantas pessoas do público da campanha enviaram pelo menos um reconhecimento dentro dela.',
        calcTotalUsers: 'Pessoas com pelo menos um reconhecimento enviado no período da campanha. Não é uma contagem histórica de toda a vida do utilizador.',
        whatNoActivity: 'Pessoas do público que não enviaram qualquer reconhecimento durante a campanha.',
        calcNoActivity: 'Público da campanha menos as pessoas com pelo menos um reconhecimento enviado nela.',
        whatAudienceStaff: 'Pessoas com conta corporativa Entra ID.',
        whatAudienceFrontline: 'Pessoas que se registam na plataforma com o seu próprio email.',
        whatParticipationRate: 'Percentagem do público-alvo que participou na campanha, reconhecendo ou sendo reconhecida.',
        calcParticipationRate: 'Participantes a dividir pelo público-alvo da campanha.',
        whatUniqueRecognizers: 'Pessoas diferentes que enviaram pelo menos um reconhecimento dentro desta campanha.',
        calcUniqueRecognizers: 'Contagem de emissores diferentes nos reconhecimentos da campanha.',
        whatDistribution: 'Hierarquia de dois níveis: cada Fundamental com a sua percentagem sobre o total da campanha e, por baixo e indentados, os seus Daily Habits com a percentagem que representam dentro desse Fundamental.',
        calcDistribution: 'A percentagem do Fundamental é o seu número de reconhecimentos a dividir pelo total da campanha. A do Hábito é o seu número de reconhecimentos a dividir pelo total do respetivo Fundamental.',
        whatFunnel: 'Segmenta o público da campanha por frequência: Habituais (quatro ou mais por mês), Ocasionais (de um a três) e Inativos (nenhum). Cada etapa é ainda desdobrada em Administrativos e Operacionais.',
        calcFunnel: 'A percentagem e a coluna Pessoas são calculadas sobre o público da campanha, não sobre toda a organização. Administrativos e Operacionais contam essas mesmas pessoas por tipo de função e ficam em branco se essa classificação não estiver disponível.',
        whatAllRecognitions: 'Detalhe em bruto da campanha, uma linha por candidato: os blocos Nominee, OnBehalfOf e Candidate completos, a data, a matriz de Hábitos ativos e os indicadores de auditoria. Não mascara pessoas: é a fonte de trabalho da comissão, e o limiar de anonimato aplica-se aos relatórios agregados.',
        calcAllRecognitions: 'Lista completa dos reconhecimentos do período, até um máximo de 5000 linhas. As colunas de Hábitos só incluem os que estão ativos no catálogo no momento da exportação. A coluna Reco_ID fica vazia porque o sistema ainda não gera um identificador único por linha.',
        whatTruncated: 'Esta transferência parou no limite de 5000 linhas: a campanha tem mais reconhecimentos do que os que o ficheiro contém.',
        calcTruncated: 'O limite foi atingido antes de percorrer todas as páginas, pelo que o ficheiro está incompleto. Restrinja o período ou a campanha e exporte de novo.',
        noteLeader: 'Uma função é considerada de líder quando tem pessoas a seu cargo.',
        masked: 'Oculto por anonimato',
        crossOuCount: '{{count}} OUs',
      },
    },
    history: {
      title: 'Históricos',
      subtitle: 'Histórico completo de uma campanha: nome e indicações recebidas.',
      selectCampaign: 'Escolha uma campanha',
      pickCampaign: 'Escolha uma campanha para ver seu histórico.',
      search: 'Procurar por nome…',
      colPos: 'Posição',
      colName: 'Nome',
      colNominations: 'Indicações',
      // C2 — «Históricos por Campaña» (rep-panel-historicos).
      colCampaign: "Campanha",
        colType: "Tipo",
        colStatus: "Estado",
      colAudience: 'Audiência (pessoas)',
        colRecognitions: "Reconhecimentos",
      colOrigin: "Origem",
        colExpiration: "Expiração",
        colActions: "Ações",
        status: {
        activo: "Ativa",
          expirado: "Expirada",
          borrador: "Rascunho",
        },
        origin: {
        original: "Original",
          local: "Local",
        },
      // P18-ter — relatório GLOBAL de campanhas (todas, não uma), calcado de 03 - Historicos.xlsx.
      kpiTotalCampaigns: 'Total de Campanhas',
      kpiTotalRecognitions: 'Total de Reconhecimentos',
      kpiAudienceTotal: 'Audiência Total',
      kpiParticipantsTotal: 'Participantes',
      kpiParticipantsStaff: 'Participantes Staff',
      kpiParticipantsFrontline: 'Participantes Frontline',
      kpiParticipationRate: 'Percentagem de Participação',
      kpiAvgPerParticipant: 'Média de reconhecimentos por participante',
      colDescription: 'Descrição',
      colParticipants: 'Participantes',
      colParticipantsStaff: 'Participantes Staff',
      colParticipantsFrontline: 'Participantes Frontline',
      colDuration: 'Duração da campanha',
      colFrequency: 'Frequência',
      colGoalPercent: '% da Meta',
      downloadGlobalExcel: 'Descarregar relatório global',
      downloadGlobalError: 'Não foi possível descarregar o relatório global.',
      // Excel de Históricos (`historicosExcel.ts`) — textos EXCLUSIVOS do ficheiro descarregável:
      // nomes de folha, banner, metadados e glossário. Os rótulos de dado reutilizam as chaves
      // `kpi*`/`col*` acima, para que a coluna do Excel e a do ecrã digam o mesmo.
      excel: {
        sheetSummary: 'Resumo Executivo',
        sheetDefinitions: 'Definições',
        sheetCampaigns: 'Campanhas Históricas',
        summaryTitle: 'Históricos por Campanha',
        summarySubtitle: 'Consolida o histórico das campanhas de reconhecimento: audiência, participação e volume de reconhecimentos de cada uma.',
        campaignsSubtitle: 'Detalhe comparativo por campanha.',
        definitionsTitle: 'O que significa cada dado?',
        definitionsSubtitle: 'Explicação em linguagem simples, alinhada com o Resumo Executivo e incluindo como se mede cada KPI.',
        metaFilter: 'Filtro aplicado',
        metaGenerated: 'Gerado',
        filterAllCampaigns: 'Todas as campanhas',
        colKpi: 'KPI',
        colValue: 'Valor',
        colNote: 'Nota / definição',
        colDatum: 'Dado',
        colWhatIs: 'O que é',
        colHowMeasured: 'Como se mede',
        colHowCalculated: 'Como se calcula',
        colComparedTo: 'Compara-se com',
        colWhereShown: 'Onde aparece',
        colAudienceOu: 'Audiência OU',
        whereSummary: 'Resumo Executivo',
        whereSummaryCampaigns: 'Resumo Executivo / Campanhas Históricas',
        datumStaffFrontline: 'Participantes Staff / Participantes Frontline',
        durationMonths_one: '{{count}} mês',
        durationMonths_few: '{{count}} meses',
        durationMonths_other: '{{count}} meses',
        whatCampaigns: 'Quantidade de campanhas incluídas no histórico ou no filtro aplicado.',
        measuredCampaigns: 'Mede-se contando cada campanha registada com nome válido no histórico.',
        calcCampaigns: 'Contagem de campanhas únicas incluídas no âmbito do relatório.',
        vsCampaigns: 'Com o universo de campanhas disponíveis ou com cortes anteriores.',
        whatRecognitions: 'Reconhecimentos acumulados dentro do âmbito selecionado.',
        measuredRecognitions: 'Mede-se como cada reconhecimento registado para as campanhas incluídas.',
        calcRecognitions: 'Soma de todos os reconhecimentos das campanhas filtradas.',
        vsRecognitions: 'Com outras campanhas, períodos anteriores ou a meta definida.',
        whatAudience: 'Número de colaboradores a quem a campanha foi dirigida.',
        measuredAudience: 'Mede-se com a audiência-alvo definida na configuração da campanha.',
        calcAudience: 'Total de colaboradores elegíveis dentro da OU, país, BU ou âmbito configurado.',
        vsAudience: 'Base para calcular a participação; 100% equivale a cobrir toda a audiência.',
        whatParticipants: 'Pessoas distintas que participaram enviando pelo menos um reconhecimento.',
        measuredParticipants: 'Mede-se contando pessoas únicas que enviaram pelo menos um reconhecimento.',
        calcParticipants: 'Contagem distinta de emissores com um ou mais reconhecimentos.',
        vsParticipants: 'Com a Audiência Total e com campanhas comparáveis.',
        whatStaffFrontline: 'Dos participantes, quantos são de escritório (Staff) e quantos são pessoal de fábrica (Frontline).',
        measuredStaffFrontline: 'Resolve-se o segmento atual de cada pessoa ao gerar o relatório, não o que tinha quando participou.',
        calcStaffFrontline: 'Contagem de participantes segundo o segmento registado na sua ficha do diretório.',
        vsStaffFrontline: 'Com o total de Participantes dessa mesma linha.',
        whatRate: 'Percentagem da audiência-alvo que participou.',
        measuredRate: 'Mede-se como a proporção de participantes sobre a audiência total.',
        calcRate: 'Participantes / Audiência Total.',
        vsRate: 'Com a meta de participação; 100% significa que toda a audiência participou.',
        whatAvg: 'Média de reconhecimentos gerados por cada participante ativo.',
        measuredAvg: 'Mede-se entre as pessoas que enviaram pelo menos um reconhecimento.',
        calcAvg: 'Total de Reconhecimentos / Participantes.',
        vsAvg: 'Com outras campanhas ou com a média esperada por participante.',
      },
    },
    headcount: {
      notaPeriodo: 'Referência do período: os KPIs acima calculam-se sobre esta população.',
      notaAdopcion: 'É o denominador da adoção: desta população, quantas pessoas nomearam.',
      title: 'Efetivos',
      updatedOn: 'Efetivos atualizados: {{fecha}}',
      hint: 'Último carregamento de utilizadores registados na plataforma',
      total: 'Total de pessoas',
      staff: 'Staff',
      frontline: 'Frontline',
    },
    heatmap: {
      title: 'Mapa de calor OU × Fundamental',
      subtitle: 'Volume de reconhecimentos por OU e Fundamental. A intensidade da cor mostra a concentração relativa dentro de cada coluna.',
      ou: 'Unidade organizacional',
      // C2 — la columna Total que la maqueta cierra en el mapa de calor.
      total: 'Total',
    },
    network: {
      title: 'Rede ONA',
      subtitle: 'Fluxo de reconhecimento entre unidades (colaboração cruzada).',
      ous: 'Unidades',
      flows: 'Fluxos',
      legendCross: 'Fluxo cross-OU',
      legendInternal: 'Fluxo interno',
      legendNode: 'Unidade (tamanho = volume)',
      // C2 — la tabla de flujos que pide la maqueta, en vez del grafo SVG.
      colFlow: 'Fluxo (De → Para)',
      colRecognitions: 'Reconhecimentos',
      // C2/C4 (2026-08-13) — reemplaza a `colIntensity`: la spec descartó el % de Intensidad y lo
      // sustituyó por el Fundamental más reconocido de la relación (`OnaEdgeDto.fundamentalDominante`).
      colDominantFundamental: 'Volume de reconhecimentos',
      colDominantFundamentalHelp: 'O comprimento da barra representa o volume de reconhecimentos do fluxo; a cor indica qual Fundamental foi o mais reconhecido nele.',
    },
    // 2026-09-04 — hoja "Definiciones" del Excel Demográfico, calcada de la plantilla del cliente
    // (`04 - Demografico.xlsx`): banner, las 4 columnas del glosario y una definición por cada dato
    // que el archivo realmente trae. Vivían como literales en español dentro de
    // `DemograficoExportButton.tsx`, así que la hoja salía en español aunque el resto del libro
    // fuera en el idioma de quien descarga.
    definitions: {
      title: 'O que significa cada dado?',
      subtitle: 'Explicação em linguagem simples para qualquer pessoa que descarregue este ficheiro, sem necessidade de conhecimentos de dados.',
      colData: 'Dado',
      colWhat: 'O que é',
      colHow: 'Como se calcula',
      colVs: 'Compara-se com',
      percentTotalWhat: 'Que parte de todo o quadro de pessoal ativo pertence a cada geração.',
      percentTotalHow: 'Pessoas ativas dessa geração, em todas as OU do âmbito, a dividir pelo total de pessoal ativo com faixa geracional conhecida.',
      percentTotalVs: 'As restantes gerações da mesma tabela.',
      gapWhat: 'Em que medida uma geração vive cada Fundamental, numa escala de 1 a 4, e a que distância fica o seu Fundamental mais baixo do mais alto.',
      gapHow: 'Média por geração e Fundamental das pontuações do Pulso; o Δ é o máximo menos o mínimo da linha, com uma casa decimal.',
      gapVs: 'Os restantes Fundamentais da mesma geração.',
      heatmapWhat: 'Quantos reconhecimentos foram dados em cada unidade organizativa, discriminados por Fundamental.',
      heatmapHow: 'Contagem agrupada por OU e Fundamental; as células com menos de 5 reconhecimentos são ocultadas por anonimato.',
      heatmapVs: 'As restantes OU e Fundamentais da mesma tabela.',
      networkWhat: 'Quantos reconhecimentos fluíram de uma unidade organizativa para outra.',
      networkHow: 'Contagem de reconhecimentos enviados de uma OU para outra, ordenada do maior para o menor.',
      networkVs: 'Os restantes fluxos da mesma tabela.',
    },
    generational: {
      title: 'Distribuição Geracional',
      subtitle: 'Reconhecimentos agrupados por faixa geracional.',
      filterBu: 'Filtrar por BU…',
      filterDepto: 'Filtrar por departamento…',
      filterSite: 'Filtrar por site…',
      roleAll: 'Todos',
      roleLeaders: 'Líderes',
      rolePeers: 'Pares',
      // Bug UAT (17-ago-2026) — estas cuatro claves vivían por error en `admin.moderation`, así
      // que `BrechaGeneracionalTable` pintaba la clave cruda («reports.generational.gapTitle»).
      // Su sitio es este bloque: las consume el tab Demográfico, no la bandeja de moderación.
      gapTitle: 'Lacuna Geracional × Fundamental',
      gapSubtitle: 'Pontuação média (1–4) por geração e Fundamental. Δ Lacuna ≥ 1,0 = crítica.',
      gapTitleHelp: 'Cada célula é arredondada a 1 casa decimal para efeitos de visualização. A Δ Lacuna é calculada sobre o valor completo (sem arredondar) do máximo menos o mínimo da linha, pelo que pode não coincidir com a subtração visual das colunas arredondadas.',
      colGeneration: 'Geração',
      colGap: 'Δ Lacuna',
      // C5/C7 (2026-08-13) — marcado visual de `ousConCobertura`: qué unidades tuvieron cobertura
      // de fecha de nacimiento suficiente para aportar al cálculo generacional.
      // T-11 — tarjetas de la maqueta: conteo de personas por banda y marca de la mayoritaria.
      people_one: '{{count}} pessoa',
      people_other: '{{count}} pessoas',
      majority: 'maioria',
      coverageTitle: 'Unidades com cobertura de dados geracionais',
      // C7 — botón de export consolidado (6 hojas) del panel Demográfico completo.
      exportConsolidated: 'Exportar painel Demográfico (5 folhas)',
      // Task 9 — etiquetas de columna para la hoja de export de distribución generacional.
      // 2026-09-03 — encabezado de la hoja "Resumen Ejecutivo" del Excel Demográfico
      // (subtítulo + bloque de metadatos), según la plantilla de referencia del cliente.
      exportSubtitle: 'Composição do quadro de pessoal por geração, OU e tipo de colaborador',
      metaPeriod: 'Período',
      metaFilters: 'Filtros aplicados',
      metaGenerated: 'Gerado',
      colPercentTotal: '% do total',
      colYearRange: 'Intervalo de anos',
      colPeople: 'Pessoas',
      colFrontline: 'Frontline',
      colStaff: 'Staff',
      colNote: 'Nota',
      // Valores de la columna «Nota» del Resumen Ejecutivo. Los emite
      // `buildGenerationalDistributionMatrix` como identificador canónico, no como texto,
      // justamente para poder traducirlos aquí.
      noteMajority: 'Maioria',
      noteSmallSample: 'Amostra pequena',
    },
    leaders: {
      title: 'Líderes',
      subtitle: 'Dimensão de equipa direta e reconhecimentos por líder.',
      export: 'Exportar para Excel',
      colLeader: 'Líder',
      colPosition: 'Cargo',
      colOu: 'UO',
      colLevel: 'Nível',
      colTeamSize: 'Dimensão da equipa',
      colTeamReceived: 'Reconhecimentos da equipa (recebidos)',
      colTeamReceivedHelp: 'Total de reconhecimentos recebidos por pessoas dentro das estruturas dos líderes.',
      colTeamSent: 'Reconhecimentos da equipa (enviados)',
      colTeamSentHelp: 'Total de reconhecimentos enviados por pessoas dentro das estruturas dos líderes.',
      colLeaderSent: 'Reconhecimentos enviados pelo líder',
      colLeaderReceived: 'Reconhecimentos recebidos pelo líder',
      colParticipation: 'Participação',
      colRatio: 'Rácio',
      colExport: 'Exportar',
      exportRow: 'Exportar esta linha',
      exportRowFor: 'Exportar a linha de {{name}}',
      kpiTotalLeaders: 'Total de líderes',
      kpiTeamSizeSum: 'Dimensão total da equipa',
      kpiRatioAvg: 'Rácio médio',
      kpiParticipationAvg: 'Participação média',
      emptyByPerson: 'A pessoa selecionada não consta em nenhuma equipa dentro do seu âmbito. Remova o filtro de pessoa para ver a tabela completa.',
      // Textos del Excel de Líderes (`leadersExcel.ts`): nombres de hoja, banner, bloque de
      // metadatos, encabezados de las hojas Resumen/Definiciones, el «Detalle» de cada KPI y el
      // glosario completo. Las etiquetas de dato NO se repiten aquí: se reusan de `col*`/`kpi*`
      // de arriba, que son las mismas que ya se leen en pantalla.
      excel: {
        sheetSummary: 'Resumo Executivo',
        sheetDefinitions: 'Definições',
        sheetTeams: 'Equipas por líder',
        teamsSubtitle: 'Detalhe de reconhecimento por estrutura hierárquica.',
        definitionsTitle: 'O que significa cada dado?',
        definitionsSubtitle: 'Explicação em linguagem simples, para qualquer pessoa que descarregue este ficheiro — sem necessidade de perceber de dados.',
        metaPeriod: 'Período',
        metaFilters: 'Filtros aplicados',
        metaGenerated: 'Gerado',
        colKpi: 'KPI',
        colValue: 'Valor',
        colDetail: 'Detalhe',
        colDatum: 'Dado',
        colWhatIs: 'O que é',
        colHowCalculated: 'Como se calcula',
        detailTotalLeaders: 'Pessoas com pelo menos um reporte direto dentro do âmbito consultado.',
        detailTeamSize: 'Soma dos reportes diretos de todos os líderes da lista.',
        detailTeamReceived: 'Reconhecimentos recebidos pelas pessoas que integram essas equipas.',
        detailTeamSent: 'Reconhecimentos enviados pelas pessoas que integram essas equipas.',
        detailLeaderReceived: 'Reconhecimentos recebidos pelos próprios líderes, sem contar a sua equipa.',
        detailLeaderSent: 'Reconhecimentos enviados pelos próprios líderes, sem contar a sua equipa.',
        detailRatio: 'Reconhecimentos de equipa recebidos divididos pelos enviados.',
        detailParticipation: 'Média de participação das equipas dos líderes.',
        whatTeamSize: 'Quantas pessoas reportam diretamente a esse líder.',
        howTeamSize: 'Contagem de pessoas cujo gestor é o líder. Não desce em cascata pelos níveis inferiores do organigrama.',
        whatTeamReceived: 'Quantos reconhecimentos recebeu no total a equipa desse líder, de qualquer pessoa.',
        howTeamReceived: 'Soma dos reconhecimentos em que o recetor pertence à equipa direta do líder.',
        whatTeamSent: 'Quantos reconhecimentos enviou no total a equipa desse líder, a qualquer pessoa.',
        howTeamSent: 'Soma dos reconhecimentos em que o emissor pertence à equipa direta do líder.',
        whatLeaderReceived: 'Quantos reconhecimentos recebeu no total o líder, de qualquer pessoa.',
        howLeaderReceived: 'Contagem de reconhecimentos em que o recetor é o líder. Não inclui a sua equipa.',
        whatLeaderSent: 'Quantos reconhecimentos enviou o líder, a qualquer pessoa.',
        howLeaderSent: 'Contagem de reconhecimentos em que o emissor é o líder. Não inclui a sua equipa.',
        whatRatio: 'Quanto mais reconhecimento recebe uma equipa, em comparação com o que reconhece aos outros.',
        howRatio: 'Reconhecimentos de equipa recebidos divididos pelos enviados. «—» se a equipa não enviou nenhum.',
        whatParticipation: 'Que percentagem da equipa desse líder já reconheceu alguém pelo menos uma vez.',
        howParticipation: 'Pessoas da equipa com pelo menos 1 reconhecimento enviado, divididas pela dimensão da equipa. Receber não conta: é uma ação de outra pessoa.',
        whatLeader: 'Colaborador que tem pessoas a seu cargo no quadro de pessoal da empresa.',
        howLeader: 'Qualquer pessoa com pelo menos um reporte direto. O resumo soma os líderes de todas as geografias do âmbito consultado.',
        whatLevel: 'Profundidade do líder no organigrama: N-1 é a raiz (sem gestor), N-2, N-3… para baixo.',
        howLevel: 'Cadeia de gestores até à raiz + 1, calculada sobre toda a empresa e não apenas entre os líderes visíveis nesta lista.',
      },
    },
    moderation: {
      title: 'Moderação',
      subtitle: 'Detalhe dos reconhecimentos reportados. Inclui dados de contacto para escalonamento.',
      total: 'Total de denúncias',
      pending: 'Pendentes',
      hidden: 'Ocultos',
      restored: 'Restaurados',
      colReported: 'Reportado',
      colReportedEmail: 'Email reportado',
      colOu: 'UO',
      colCountry: 'País',
      colReporter: 'Denunciante',
      colReporterEmail: 'Email denunciante',
      colReason: 'Motivo',
      colStatus: 'Estado',
      colDate: 'Data',
      statusPending: 'Pendente',
      statusHidden: 'Oculto',
      statusRestored: 'Restaurado',
      statusPublished: 'Publicado',
      colComment: 'Comentário reportado',
      colLanguage: 'Idioma',
      colReportCount: '# Denúncias',
      export: 'Exportar para Excel',
    },
    campaigns: {
      title: 'Histórico de campanhas',
      subtitle: 'Todas as campanhas (ativas e expiradas): audiência e reconhecimentos.',
      search: 'Procurar por nome…',
      // D4 — seletor de categoria (Fundamentales/Brillamos/Personalizada) que substituiu a
      // exportação combinada da tabela.
      filterTypeLabel: 'Categoria',
      filterAllTypes: 'Todas as categorias',
      summaryParticipants: 'Total de participantes',
      summaryRate: '% de participação',
      colName: 'Nome',
      colType: 'Tipo',
      colStatus: 'Estado',
      colAudience: 'Audiência (pessoas)',
      colRecognitions: 'Reconhecimentos',
      // C2 — «Participação por Campanha» (rep-panel-campgeneral).
      colParticipants: 'Participantes',
      colRate: 'Taxa de participação',
      colAvgUser: 'Média por participante',
      colAvgUserHelp: 'Reconhecimentos médios gerados por cada participante da campanha: reconhecimentos ÷ participantes.',
      dominantFundamentalTooltip: 'Fundamental mais reconhecido: {{name}}',
      colExpiration: 'Data de expiração',
      colActions: 'Ações',
      prevPage: 'Anterior',
      nextPage: 'Próxima',
      pageOf: 'Página {{page}} de {{total}}',
      type: {
        Fundamentales: 'Fundamentais',
        Brillamos: 'Shine Together',
        Personalizada: 'Personalizada',
      },
      status: {
        activo: 'Ativo',
        finalizada: 'Expirada',
        borrador: 'Rascunho',
      },
      // D3 — Reportería deja de ofrecer pausar/relanzar/enviar-a-aprobación (esa máquina de estados
      // vive en el editor de campañas, `admin.campaigns`). Queda una sola acción por fila: descargar
      // el Excel de esa campaña.
      downloadExcel: 'Descarregar Excel',
      // D6 — erro visível ao utilizador quando falha a exportação da campanha (rede/backend), via Toast.
      downloadError: 'Não foi possível descarregar o Excel da campanha.',
    },
  },
  // ── D5 Pass-C — Preferências, equipe, painel, leaderboard, campanha personalizada ──
  notifPrefs: {
    title: 'Notificações',
    subtitle: 'Escolha quais avisos quer receber por e-mail.',
    unavailable: 'Não foi possível carregar suas preferências.',
    emailEnabled: 'Receber e-mails',
    emailHint: 'Chave geral de todos os e-mails.',
    saveError: 'Não foi possível guardar suas preferências.',
    cat: {
      recognitionReceived: 'Reconhecimentos recebidos',
      streakAndBadges: 'Sequências e insígnias',
      campaigns: 'Campanhas',
      digest: 'Resumo de atividade',
    },
    catHint: {
      recognitionReceived: 'Quando alguém te reconhece.',
      streakAndBadges: 'Sua sequência e insígnias desbloqueadas.',
      campaigns: 'Novidades de campanhas Brilhamos.',
      digest: 'Resumo periódico da sua atividade.',
    },
    catLockedAntiSpoiler: 'Bloqueado enquanto o Modo Anti-Spoiler estiver ativo: não podemos avisar-te dos teus reconhecimentos até a campanha terminar.',
  },
  team: {
    mostRecognized: 'Mais Reconhecidos', mostRecognizers: 'Mais Reconhecedores',
    title: 'Minha equipa',
    subtitle: 'Participação da sua equipa no reconhecimento.',
    subtitleFor: 'Equipa de {{name}}',
    empty: 'Ainda não há atividade da sua equipa.',
    teamSize: 'Tamanho da equipa',
    sent: 'Enviados',
    received: 'Recebidos',
    participation: 'Participação',
    members: 'Membros da equipa',
    emptyMembers: 'Não há membros para mostrar.',
    colMember: 'Membro',
    colSent: 'Enviados',
    colReceived: 'Recebidos',
    colStreak: 'Sequência',
    noStreak: 'Sem sequência',
    explore: 'Explorar a sua equipa',
    myTeam: 'A minha equipa',
    breadcrumb: 'Percurso de equipas',
    colTopFundamental: 'Top fundamental',
    // La celda lleva las DOS lecturas etiquetadas: por lo que RECONOCEN a la persona (el dato
    // que existe para todo el equipo) y lo que ella usa al reconocer (UAT 18-ago-2026).
    fundRecibido: 'É reconhecido por:',
    fundEnviado: 'Reconhece por:',
    colActions: 'Ações',
    viewButton: 'Ver perfil de {{name}}',
    viewButton_short: 'Ver',
    backToTeam: 'Voltar à equipa',
    backToProfile: 'Voltar ao meu perfil',
    expandMember: 'Ver detalhes de {{name}}',
  },
  tablero: {
    title: 'Painel executivo',
    subtitle: 'KPIs do Programa de Reconhecimento. Nunca mostra pontos.',
    empty: 'Não há KPIs para o alcance selecionado.',
    // RF-143 (C4) — drill-down por Fundamental y por generación.
    allFundamentals: 'Todos os Fundamentos',
    allGenerations: 'Todas as gerações',
    notApplicableNote: 'Com o filtro de geração, os KPIs calculados sobre o efetivo total aparecem como «n/a»: o censo não é desagregado por geração, pelo que essa percentagem significaria outra coisa.',
    // 🔴 Las CLAVES son los valores exactos de GenerationHelper (UserAdminService); solo se
    //    traduce el rótulo. Cambiar una clave dejaría el filtro sin casar con nadie.
    generations: {
      GenAlpha: 'Geração Alfa',
      GenZ: 'Geração Z',
      Millennial: 'Millennials',
      GenX: 'Geração X',
      BabyBoomer: 'Baby Boomers',
      Silent: 'Geração Silenciosa',
    },
  },
  leaderboard: {
    title: 'Ranking por OU',
    subtitle: 'Nomeações por unidade organizacional/país.',
    noOu: 'Sem OU',
    you: ' (tu)',
  },
  campaignType: {
    personalizada: 'Campanha personalizada',
  },
  campaignLanding: {
    customNote: 'Esta é uma campanha informativa. Explore seus documentos e microsite.',
  },
  innovacion: {
    kpiStreak: 'Sequência',
    kpiStreakHint: 'recorde: {{record}} semanas',
    kpiStreakHintMonthly: 'recorde: {{record}} meses',
    kpiNominations: 'Nomeações',
    kpiNominationsHint: 'Enviadas nesta campanha',
    kpiNominationsHint2: '{{count}} pessoas distintas',
    kpiUnique: 'Pessoas nomeadas',
    kpiUniqueHint: 'Receptores únicos',
    kpiDaysLeft: 'Dias restantes',
    suppressed: 'Os dados estão suprimidos por privacidade: o grupo é pequeno demais para mostrar números.',
    kpisUnavailable: 'Os KPIs ao vivo não estão disponíveis no momento.',
    fundamentalsTitle: 'Fundamentais desta campanha',
    nominateSecondary: 'Ir à página de Nomear',
    recentTitle: 'Reconhecimentos recentes',
    recentEmpty: 'Ainda não há reconhecimentos nesta campanha.',
    noCampaign: 'Não há nenhuma campanha personalizada ativa. Pode ser criada em Administração → Campanhas.',
  },
};

export default recognition;
